/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Accepted file types for file upload fields.
 * @export
 * @interface AcceptedFileTypesSetting
 */
export interface AcceptedFileTypesSetting {
    /**
     * 
     * @type {string}
     * @memberof AcceptedFileTypesSetting
     */
    'type'?: AcceptedFileTypesSettingTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof AcceptedFileTypesSetting
     */
    'types': Array<string>;
}

export const AcceptedFileTypesSettingTypeEnum = {
    AcceptedFileTypes: 'accepted_file_types'
} as const;

export type AcceptedFileTypesSettingTypeEnum = typeof AcceptedFileTypesSettingTypeEnum[keyof typeof AcceptedFileTypesSettingTypeEnum];

/**
 * Whether multiple selections are allowed.
 * @export
 * @interface AllowMultipleSetting
 */
export interface AllowMultipleSetting {
    /**
     * 
     * @type {string}
     * @memberof AllowMultipleSetting
     */
    'type'?: AllowMultipleSettingTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AllowMultipleSetting
     */
    'value': boolean;
}

export const AllowMultipleSettingTypeEnum = {
    AllowMultiple: 'allow_multiple'
} as const;

export type AllowMultipleSettingTypeEnum = typeof AllowMultipleSettingTypeEnum[keyof typeof AllowMultipleSettingTypeEnum];

/**
 * Status values for application form submissions.
 * @export
 * @enum {string}
 */

export const ApplicationStatus = {
    Pending: 'pending',
    UnderReview: 'under_review',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Waitlisted: 'waitlisted'
} as const;

export type ApplicationStatus = typeof ApplicationStatus[keyof typeof ApplicationStatus];


/**
 * Input for retrieving field responses for multiple submissions.
 * @export
 * @interface BulkGetSubmissionResponsesInput
 */
export interface BulkGetSubmissionResponsesInput {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkGetSubmissionResponsesInput
     */
    'submission_ids': Array<string>;
}
/**
 * Actions to take when a condition is met.
 * @export
 * @enum {string}
 */

export const ConditionalAction = {
    Show: 'show',
    Hide: 'hide',
    Require: 'require',
    Optional: 'optional',
    Disable: 'disable',
    Enable: 'enable'
} as const;

export type ConditionalAction = typeof ConditionalAction[keyof typeof ConditionalAction];


/**
 * Operators for conditional logic evaluation.
 * @export
 * @enum {string}
 */

export const ConditionalOperator = {
    Equals: 'equals',
    NotEquals: 'not_equals',
    Contains: 'contains',
    NotContains: 'not_contains',
    IsEmpty: 'is_empty',
    IsNotEmpty: 'is_not_empty',
    GreaterThan: 'greater_than',
    LessThan: 'less_than',
    InList: 'in_list',
    NotInList: 'not_in_list'
} as const;

export type ConditionalOperator = typeof ConditionalOperator[keyof typeof ConditionalOperator];


/**
 * Make a field required or optional based on another field\'s value.  Similar to ConditionalVisibilitySetting but specifically for toggling the required validation state of a field.  Examples:     - Require \"Business License\" when \"Business Type\" is \"LLC\"     - Make \"Phone Number\" required when \"Contact Method\" is \"Phone\"
 * @export
 * @interface ConditionalRequirementSetting
 */
export interface ConditionalRequirementSetting {
    /**
     * 
     * @type {string}
     * @memberof ConditionalRequirementSetting
     */
    'type'?: ConditionalRequirementSettingTypeEnum;
    /**
     * ID of the field whose value triggers this condition
     * @type {string}
     * @memberof ConditionalRequirementSetting
     */
    'source_field_id': string;
    /**
     * 
     * @type {ConditionalOperator}
     * @memberof ConditionalRequirementSetting
     */
    'operator': ConditionalOperator;
    /**
     * 
     * @type {Value}
     * @memberof ConditionalRequirementSetting
     */
    'value'?: Value;
    /**
     * If True, field becomes required when condition is met. If False, becomes optional.
     * @type {boolean}
     * @memberof ConditionalRequirementSetting
     */
    'make_required'?: boolean;
}

export const ConditionalRequirementSettingTypeEnum = {
    ConditionalRequirement: 'conditional_requirement'
} as const;

export type ConditionalRequirementSettingTypeEnum = typeof ConditionalRequirementSettingTypeEnum[keyof typeof ConditionalRequirementSettingTypeEnum];

/**
 * Show or hide a field based on another field\'s value.  The condition is evaluated on the frontend to dynamically show/hide fields. When the source field\'s value matches the condition, the action is applied to the field that has this setting.  Examples:     - Show \"Other\" text field when \"Other\" is selected in a dropdown     - Hide \"Spouse Name\" field when \"Single\" is selected for marital status     - Show \"Company Name\" field when \"Employed\" checkbox is checked
 * @export
 * @interface ConditionalVisibilitySetting
 */
export interface ConditionalVisibilitySetting {
    /**
     * 
     * @type {string}
     * @memberof ConditionalVisibilitySetting
     */
    'type'?: ConditionalVisibilitySettingTypeEnum;
    /**
     * ID of the field whose value triggers this condition
     * @type {string}
     * @memberof ConditionalVisibilitySetting
     */
    'source_field_id': string;
    /**
     * 
     * @type {ConditionalOperator}
     * @memberof ConditionalVisibilitySetting
     */
    'operator': ConditionalOperator;
    /**
     * 
     * @type {Value}
     * @memberof ConditionalVisibilitySetting
     */
    'value'?: Value;
    /**
     * 
     * @type {ConditionalAction}
     * @memberof ConditionalVisibilitySetting
     */
    'action'?: ConditionalAction;
}

export const ConditionalVisibilitySettingTypeEnum = {
    ConditionalVisibility: 'conditional_visibility'
} as const;

export type ConditionalVisibilitySettingTypeEnum = typeof ConditionalVisibilitySettingTypeEnum[keyof typeof ConditionalVisibilitySettingTypeEnum];

/**
 * Input for creating a field option.
 * @export
 * @interface CreateFieldOptionInput
 */
export interface CreateFieldOptionInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateFieldOptionInput
     */
    'field_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFieldOptionInput
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFieldOptionInput
     */
    'value': string;
    /**
     * 
     * @type {number}
     * @memberof CreateFieldOptionInput
     */
    'order_index'?: number;
}
/**
 * 
 * @export
 * @interface CreateFieldTemplateInput
 */
export interface CreateFieldTemplateInput {
    /**
     * 
     * @type {string}
     * @memberof CreateFieldTemplateInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFieldTemplateInput
     */
    'description'?: string;
    /**
     * 
     * @type {FieldType}
     * @memberof CreateFieldTemplateInput
     */
    'field_type': FieldType;
    /**
     * 
     * @type {FieldValueType}
     * @memberof CreateFieldTemplateInput
     */
    'value_type': FieldValueType;
    /**
     * 
     * @type {string}
     * @memberof CreateFieldTemplateInput
     */
    'default_label': string;
    /**
     * 
     * @type {Array<DefaultSettingsInner>}
     * @memberof CreateFieldTemplateInput
     */
    'default_settings'?: Array<DefaultSettingsInner>;
}


/**
 * 
 * @export
 * @interface CreateFormFieldInput
 */
export interface CreateFormFieldInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateFormFieldInput
     */
    'form_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFormFieldInput
     */
    'name': string;
    /**
     * 
     * @type {FieldType}
     * @memberof CreateFormFieldInput
     */
    'field_type': FieldType;
    /**
     * 
     * @type {FieldValueType}
     * @memberof CreateFormFieldInput
     */
    'value_type': FieldValueType;
    /**
     * 
     * @type {string}
     * @memberof CreateFormFieldInput
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFormFieldInput
     */
    'help_text'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateFormFieldInput
     */
    'order_index'?: number;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateFormFieldInput
     */
    'template_id'?: string;
    /**
     * 
     * @type {Array<DefaultSettingsInner>}
     * @memberof CreateFormFieldInput
     */
    'settings'?: Array<DefaultSettingsInner>;
}


/**
 * 
 * @export
 * @interface CreateFormInput
 */
export interface CreateFormInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateFormInput
     */
    'community_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFormInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFormInput
     */
    'description'?: string;
    /**
     * 
     * @type {FormType}
     * @memberof CreateFormInput
     */
    'form_type': FormType;
    /**
     * 
     * @type {string}
     * @memberof CreateFormInput
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFormInput
     */
    'slug'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFormInput
     */
    'is_published'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateFormInput
     */
    'submit_button_text'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFormInput
     */
    'success_message'?: string;
}


/**
 * 
 * @export
 * @interface CreateFormSubmissionInput
 */
export interface CreateFormSubmissionInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateFormSubmissionInput
     */
    'form_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateFormSubmissionInput
     */
    'user_id'?: string;
    /**
     * 
     * @type {Array<FieldResponseInput>}
     * @memberof CreateFormSubmissionInput
     */
    'field_responses': Array<FieldResponseInput>;
}
/**
 * Input for creating a form tag mapping.
 * @export
 * @interface CreateFormTagMappingInput
 */
export interface CreateFormTagMappingInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateFormTagMappingInput
     */
    'form_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateFormTagMappingInput
     */
    'field_id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateFormTagMappingInput
     */
    'field_option_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFormTagMappingInput
     */
    'canonical_tag_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateFormTagMappingInput
     */
    'community_id': string;
}
/**
 * 
 * @export
 * @interface CreateLinkInput
 */
export interface CreateLinkInput {
    /**
     * 
     * @type {string}
     * @memberof CreateLinkInput
     */
    'original_url': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLinkInput
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLinkInput
     */
    'description'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateLinkInput
     */
    'community_id': string;
    /**
     * 
     * @type {number}
     * @memberof CreateLinkInput
     */
    'max_clicks'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateLinkInput
     */
    'expires_at'?: string;
    /**
     * 
     * @type {object}
     * @memberof CreateLinkInput
     */
    'tracking_parameters'?: object;
}
/**
 * @type DefaultSettingsInner
 * @export
 */
export type DefaultSettingsInner = { type: 'accepted_file_types' } & AcceptedFileTypesSetting | { type: 'allow_multiple' } & AllowMultipleSetting | { type: 'conditional_requirement' } & ConditionalRequirementSetting | { type: 'conditional_visibility' } & ConditionalVisibilitySetting | { type: 'default_value' } & DefaultValueSetting | { type: 'disabled' } & DisabledSetting | { type: 'max_file_size' } & MaxFileSizeSetting | { type: 'max_length' } & MaxLengthSetting | { type: 'max_selections' } & MaxSelectionsSetting | { type: 'max_value' } & MaxValueSetting | { type: 'min_length' } & MinLengthSetting | { type: 'min_value' } & MinValueSetting | { type: 'options' } & OptionsSetting | { type: 'pattern' } & PatternSetting | { type: 'placeholder' } & PlaceholderSetting | { type: 'readonly' } & ReadonlySetting | { type: 'required' } & RequiredSetting | { type: 'searchable' } & SearchableSetting;

/**
 * Default value for the field.
 * @export
 * @interface DefaultValueSetting
 */
export interface DefaultValueSetting {
    /**
     * 
     * @type {string}
     * @memberof DefaultValueSetting
     */
    'type'?: DefaultValueSettingTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DefaultValueSetting
     */
    'value': string;
}

export const DefaultValueSettingTypeEnum = {
    DefaultValue: 'default_value'
} as const;

export type DefaultValueSettingTypeEnum = typeof DefaultValueSettingTypeEnum[keyof typeof DefaultValueSettingTypeEnum];

/**
 * Response model for field option deletion endpoint.
 * @export
 * @interface DeleteFieldOptionOutput
 */
export interface DeleteFieldOptionOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof DeleteFieldOptionOutput
     */
    'field_option_id': string;
}
/**
 * Response model for field template deletion endpoint.
 * @export
 * @interface DeleteFieldTemplateOutput
 */
export interface DeleteFieldTemplateOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof DeleteFieldTemplateOutput
     */
    'field_template_id': string;
}
/**
 * Response model for form field deletion endpoint.
 * @export
 * @interface DeleteFormFieldOutput
 */
export interface DeleteFormFieldOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof DeleteFormFieldOutput
     */
    'form_field_id': string;
}
/**
 * Response model for form deletion endpoint.
 * @export
 * @interface DeleteFormOutput
 */
export interface DeleteFormOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof DeleteFormOutput
     */
    'form_id': string;
}
/**
 * Response model for form submission deletion endpoint.
 * @export
 * @interface DeleteFormSubmissionOutput
 */
export interface DeleteFormSubmissionOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof DeleteFormSubmissionOutput
     */
    'form_submission_id': string;
}
/**
 * Response model for form tag mapping deletion endpoint.
 * @export
 * @interface DeleteFormTagMappingOutput
 */
export interface DeleteFormTagMappingOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof DeleteFormTagMappingOutput
     */
    'mapping_id': string;
}
/**
 * Response model for link deletion endpoint.
 * @export
 * @interface DeleteLinkOutput
 */
export interface DeleteLinkOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof DeleteLinkOutput
     */
    'link_id': string;
}
/**
 * Whether the field is disabled.
 * @export
 * @interface DisabledSetting
 */
export interface DisabledSetting {
    /**
     * 
     * @type {string}
     * @memberof DisabledSetting
     */
    'type'?: DisabledSettingTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DisabledSetting
     */
    'value': boolean;
}

export const DisabledSettingTypeEnum = {
    Disabled: 'disabled'
} as const;

export type DisabledSettingTypeEnum = typeof DisabledSettingTypeEnum[keyof typeof DisabledSettingTypeEnum];

/**
 * Individual option for fields with predefined choices.
 * @export
 * @interface FieldOption
 */
export interface FieldOption {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof FieldOption
     */
    'id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof FieldOption
     */
    'field_id': string;
    /**
     * 
     * @type {string}
     * @memberof FieldOption
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof FieldOption
     */
    'value': string;
    /**
     * 
     * @type {number}
     * @memberof FieldOption
     */
    'order_index': number;
    /**
     * 
     * @type {boolean}
     * @memberof FieldOption
     */
    'is_active'?: boolean;
}
/**
 * Single field option order specification.
 * @export
 * @interface FieldOptionOrderItem
 */
export interface FieldOptionOrderItem {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof FieldOptionOrderItem
     */
    'option_id': string;
    /**
     * 
     * @type {number}
     * @memberof FieldOptionOrderItem
     */
    'order_index': number;
}
/**
 * Single field order specification.
 * @export
 * @interface FieldOrderItem
 */
export interface FieldOrderItem {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof FieldOrderItem
     */
    'field_id': string;
    /**
     * 
     * @type {number}
     * @memberof FieldOrderItem
     */
    'order_index': number;
}
/**
 * A single field response value.
 * @export
 * @interface FieldResponseInput
 */
export interface FieldResponseInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof FieldResponseInput
     */
    'field_id': string;
    /**
     * 
     * @type {any}
     * @memberof FieldResponseInput
     */
    'value'?: any;
}
/**
 * Individual setting value applied to a specific FormField.
 * @export
 * @interface FieldSetting
 */
export interface FieldSetting {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof FieldSetting
     */
    'id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof FieldSetting
     */
    'field_id': string;
    /**
     * 
     * @type {string}
     * @memberof FieldSetting
     */
    'setting_type_name': string;
    /**
     * 
     * @type {object}
     * @memberof FieldSetting
     */
    'value': object;
}
/**
 * Reusable field template with predefined settings.
 * @export
 * @interface FieldTemplate
 */
export interface FieldTemplate {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof FieldTemplate
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldTemplate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FieldTemplate
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldTemplate
     */
    'field_type': string;
    /**
     * 
     * @type {string}
     * @memberof FieldTemplate
     */
    'value_type': string;
    /**
     * 
     * @type {string}
     * @memberof FieldTemplate
     */
    'default_label': string;
    /**
     * 
     * @type {Array<object>}
     * @memberof FieldTemplate
     */
    'default_settings': Array<object>;
    /**
     * 
     * @type {boolean}
     * @memberof FieldTemplate
     */
    'is_active'?: boolean;
}
/**
 * Available field types for form fields (UI component types).
 * @export
 * @enum {string}
 */

export const FieldType = {
    Text: 'text',
    Email: 'email',
    Number: 'number',
    Textarea: 'textarea',
    Checkbox: 'checkbox',
    Radio: 'radio',
    Select: 'select',
    Multiselect: 'multiselect',
    Date: 'date',
    Time: 'time',
    Datetime: 'datetime',
    File: 'file',
    Url: 'url',
    Tel: 'tel',
    Password: 'password',
    Hidden: 'hidden'
} as const;

export type FieldType = typeof FieldType[keyof typeof FieldType];


/**
 * Value storage types for form field responses.
 * @export
 * @enum {string}
 */

export const FieldValueType = {
    Text: 'text',
    Number: 'number',
    Boolean: 'boolean',
    Date: 'date',
    Time: 'time',
    Datetime: 'datetime',
    Json: 'json'
} as const;

export type FieldValueType = typeof FieldValueType[keyof typeof FieldValueType];


/**
 * A form is a collection of fields with a specific configuration.
 * @export
 * @interface Form
 */
export interface Form {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Form
     */
    'id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Form
     */
    'community_id': string;
    /**
     * 
     * @type {string}
     * @memberof Form
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Form
     */
    'description'?: string;
    /**
     * 
     * @type {FormType}
     * @memberof Form
     */
    'form_type': FormType;
    /**
     * 
     * @type {string}
     * @memberof Form
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Form
     */
    'slug'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Form
     */
    'is_published': boolean;
    /**
     * 
     * @type {string}
     * @memberof Form
     */
    'submit_button_text': string;
    /**
     * 
     * @type {string}
     * @memberof Form
     */
    'success_message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Form
     */
    'is_active'?: boolean;
}


/**
 * An individual field instance that belongs to a specific form.
 * @export
 * @interface FormField
 */
export interface FormField {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof FormField
     */
    'id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof FormField
     */
    'form_id': string;
    /**
     * 
     * @type {string}
     * @memberof FormField
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FormField
     */
    'field_type': string;
    /**
     * 
     * @type {string}
     * @memberof FormField
     */
    'value_type': string;
    /**
     * 
     * @type {string}
     * @memberof FormField
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof FormField
     */
    'help_text'?: string;
    /**
     * 
     * @type {number}
     * @memberof FormField
     */
    'order_index': number;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof FormField
     */
    'template_id'?: string;
    /**
     * 
     * @type {Array<FieldOption>}
     * @memberof FormField
     */
    'options'?: Array<FieldOption>;
    /**
     * 
     * @type {Array<FieldSetting>}
     * @memberof FormField
     */
    'settings'?: Array<FieldSetting>;
    /**
     * 
     * @type {boolean}
     * @memberof FormField
     */
    'is_active'?: boolean;
}
/**
 * Output model for a single form field response.
 * @export
 * @interface FormFieldResponseOutput
 */
export interface FormFieldResponseOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof FormFieldResponseOutput
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof FormFieldResponseOutput
     */
    'submission_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof FormFieldResponseOutput
     */
    'field_id': string;
    /**
     * 
     * @type {string}
     * @memberof FormFieldResponseOutput
     */
    'value_text'?: string;
    /**
     * 
     * @type {number}
     * @memberof FormFieldResponseOutput
     */
    'value_number'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FormFieldResponseOutput
     */
    'value_boolean'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FormFieldResponseOutput
     */
    'value_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormFieldResponseOutput
     */
    'value_time'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormFieldResponseOutput
     */
    'value_datetime'?: string;
    /**
     * 
     * @type {ValueJson}
     * @memberof FormFieldResponseOutput
     */
    'value_json'?: ValueJson;
    /**
     * 
     * @type {Array<SelectedOptionOutput>}
     * @memberof FormFieldResponseOutput
     */
    'selected_options'?: Array<SelectedOptionOutput>;
}
/**
 * A user\'s submission of a form.
 * @export
 * @interface FormSubmission
 */
export interface FormSubmission {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof FormSubmission
     */
    'id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof FormSubmission
     */
    'form_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof FormSubmission
     */
    'user_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FormSubmission
     */
    'is_reviewed': boolean;
    /**
     * 
     * @type {string}
     * @memberof FormSubmission
     */
    'reviewer_notes'?: string;
    /**
     * 
     * @type {ApplicationStatus}
     * @memberof FormSubmission
     */
    'current_status'?: ApplicationStatus;
    /**
     * 
     * @type {boolean}
     * @memberof FormSubmission
     */
    'is_active'?: boolean;
}


/**
 * Maps forms and form fields to canonical tags they trigger.
 * @export
 * @interface FormTagMapping
 */
export interface FormTagMapping {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof FormTagMapping
     */
    'id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof FormTagMapping
     */
    'form_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof FormTagMapping
     */
    'field_id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof FormTagMapping
     */
    'field_option_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormTagMapping
     */
    'canonical_tag_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof FormTagMapping
     */
    'community_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof FormTagMapping
     */
    'is_active'?: boolean;
}
/**
 * Available form types.
 * @export
 * @enum {string}
 */

export const FormType = {
    Checkout: 'checkout',
    Shareable: 'shareable',
    Application: 'application'
} as const;

export type FormType = typeof FormType[keyof typeof FormType];


/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * Pydantic model for Link.
 * @export
 * @interface Link
 */
export interface Link {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Link
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    'original_url': string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    'description'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Link
     */
    'community_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof Link
     */
    'is_system_generated'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Link
     */
    'current_click_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof Link
     */
    'unique_click_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof Link
     */
    'max_clicks'?: number;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    'expires_at'?: string;
    /**
     * 
     * @type {object}
     * @memberof Link
     */
    'tracking_parameters'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof Link
     */
    'is_active'?: boolean;
}
/**
 * Response model for link analytics endpoint.
 * @export
 * @interface LinkAnalyticsOutput
 */
export interface LinkAnalyticsOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof LinkAnalyticsOutput
     */
    'link_id': string;
    /**
     * 
     * @type {number}
     * @memberof LinkAnalyticsOutput
     */
    'total_clicks': number;
    /**
     * 
     * @type {number}
     * @memberof LinkAnalyticsOutput
     */
    'unique_clicks': number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof LinkAnalyticsOutput
     */
    'clicks_by_device': { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof LinkAnalyticsOutput
     */
    'clicks_by_browser': { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof LinkAnalyticsOutput
     */
    'clicks_by_referer': { [key: string]: number; };
}
/**
 * Pydantic model for LinkClick.
 * @export
 * @interface LinkClick
 */
export interface LinkClick {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof LinkClick
     */
    'id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof LinkClick
     */
    'link_id': string;
    /**
     * 
     * @type {string}
     * @memberof LinkClick
     */
    'clicked_at': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof LinkClick
     */
    'user_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkClick
     */
    'ip_address'?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkClick
     */
    'user_agent'?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkClick
     */
    'device_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkClick
     */
    'browser'?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkClick
     */
    'operating_system'?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkClick
     */
    'referer'?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkClick
     */
    'referer_domain'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LinkClick
     */
    'is_unique'?: boolean;
}
/**
 * 
 * @export
 * @interface LocationInner
 */
export interface LocationInner {
}
/**
 * Maximum file size in bytes.
 * @export
 * @interface MaxFileSizeSetting
 */
export interface MaxFileSizeSetting {
    /**
     * 
     * @type {string}
     * @memberof MaxFileSizeSetting
     */
    'type'?: MaxFileSizeSettingTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof MaxFileSizeSetting
     */
    'value'?: number;
}

export const MaxFileSizeSettingTypeEnum = {
    MaxFileSize: 'max_file_size'
} as const;

export type MaxFileSizeSettingTypeEnum = typeof MaxFileSizeSettingTypeEnum[keyof typeof MaxFileSizeSettingTypeEnum];

/**
 * Maximum character length.
 * @export
 * @interface MaxLengthSetting
 */
export interface MaxLengthSetting {
    /**
     * 
     * @type {string}
     * @memberof MaxLengthSetting
     */
    'type'?: MaxLengthSettingTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof MaxLengthSetting
     */
    'value': number;
}

export const MaxLengthSettingTypeEnum = {
    MaxLength: 'max_length'
} as const;

export type MaxLengthSettingTypeEnum = typeof MaxLengthSettingTypeEnum[keyof typeof MaxLengthSettingTypeEnum];

/**
 * Maximum number of selections for multiselect fields.
 * @export
 * @interface MaxSelectionsSetting
 */
export interface MaxSelectionsSetting {
    /**
     * 
     * @type {string}
     * @memberof MaxSelectionsSetting
     */
    'type'?: MaxSelectionsSettingTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof MaxSelectionsSetting
     */
    'value': number;
}

export const MaxSelectionsSettingTypeEnum = {
    MaxSelections: 'max_selections'
} as const;

export type MaxSelectionsSettingTypeEnum = typeof MaxSelectionsSettingTypeEnum[keyof typeof MaxSelectionsSettingTypeEnum];

/**
 * Maximum numeric value.
 * @export
 * @interface MaxValueSetting
 */
export interface MaxValueSetting {
    /**
     * 
     * @type {string}
     * @memberof MaxValueSetting
     */
    'type'?: MaxValueSettingTypeEnum;
    /**
     * 
     * @type {Value1}
     * @memberof MaxValueSetting
     */
    'value': Value1;
}

export const MaxValueSettingTypeEnum = {
    MaxValue: 'max_value'
} as const;

export type MaxValueSettingTypeEnum = typeof MaxValueSettingTypeEnum[keyof typeof MaxValueSettingTypeEnum];

/**
 * Minimum character length.
 * @export
 * @interface MinLengthSetting
 */
export interface MinLengthSetting {
    /**
     * 
     * @type {string}
     * @memberof MinLengthSetting
     */
    'type'?: MinLengthSettingTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof MinLengthSetting
     */
    'value': number;
}

export const MinLengthSettingTypeEnum = {
    MinLength: 'min_length'
} as const;

export type MinLengthSettingTypeEnum = typeof MinLengthSettingTypeEnum[keyof typeof MinLengthSettingTypeEnum];

/**
 * Minimum numeric value.
 * @export
 * @interface MinValueSetting
 */
export interface MinValueSetting {
    /**
     * 
     * @type {string}
     * @memberof MinValueSetting
     */
    'type'?: MinValueSettingTypeEnum;
    /**
     * 
     * @type {Value1}
     * @memberof MinValueSetting
     */
    'value': Value1;
}

export const MinValueSettingTypeEnum = {
    MinValue: 'min_value'
} as const;

export type MinValueSettingTypeEnum = typeof MinValueSettingTypeEnum[keyof typeof MinValueSettingTypeEnum];

/**
 * DEPRECATED: Options are now stored in the FieldOption table. This setting type is kept for backwards compatibility but should not be used for new fields.
 * @export
 * @interface OptionsSetting
 */
export interface OptionsSetting {
    /**
     * 
     * @type {string}
     * @memberof OptionsSetting
     */
    'type'?: OptionsSettingTypeEnum;
    /**
     * 
     * @type {Array<SelectOption>}
     * @memberof OptionsSetting
     */
    'options': Array<SelectOption>;
}

export const OptionsSettingTypeEnum = {
    Options: 'options'
} as const;

export type OptionsSettingTypeEnum = typeof OptionsSettingTypeEnum[keyof typeof OptionsSettingTypeEnum];

/**
 * Regular expression pattern for validation.
 * @export
 * @interface PatternSetting
 */
export interface PatternSetting {
    /**
     * 
     * @type {string}
     * @memberof PatternSetting
     */
    'type'?: PatternSettingTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PatternSetting
     */
    'value': string;
}

export const PatternSettingTypeEnum = {
    Pattern: 'pattern'
} as const;

export type PatternSettingTypeEnum = typeof PatternSettingTypeEnum[keyof typeof PatternSettingTypeEnum];

/**
 * Placeholder text shown when field is empty.
 * @export
 * @interface PlaceholderSetting
 */
export interface PlaceholderSetting {
    /**
     * 
     * @type {string}
     * @memberof PlaceholderSetting
     */
    'type'?: PlaceholderSettingTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PlaceholderSetting
     */
    'value': string;
}

export const PlaceholderSettingTypeEnum = {
    Placeholder: 'placeholder'
} as const;

export type PlaceholderSettingTypeEnum = typeof PlaceholderSettingTypeEnum[keyof typeof PlaceholderSettingTypeEnum];

/**
 * Whether the field is read-only.
 * @export
 * @interface ReadonlySetting
 */
export interface ReadonlySetting {
    /**
     * 
     * @type {string}
     * @memberof ReadonlySetting
     */
    'type'?: ReadonlySettingTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ReadonlySetting
     */
    'value': boolean;
}

export const ReadonlySettingTypeEnum = {
    Readonly: 'readonly'
} as const;

export type ReadonlySettingTypeEnum = typeof ReadonlySettingTypeEnum[keyof typeof ReadonlySettingTypeEnum];

/**
 * Input for recording a link click from client.  IP address will be extracted from request headers server-side. Client sends all other tracking data (user_agent, referer, device info).
 * @export
 * @interface RecordLinkClickInput
 */
export interface RecordLinkClickInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof RecordLinkClickInput
     */
    'link_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof RecordLinkClickInput
     */
    'user_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecordLinkClickInput
     */
    'user_agent'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecordLinkClickInput
     */
    'referer'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecordLinkClickInput
     */
    'referer_domain'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecordLinkClickInput
     */
    'device_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecordLinkClickInput
     */
    'browser'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecordLinkClickInput
     */
    'operating_system'?: string;
}
/**
 * Response model for successful redirect.
 * @export
 * @interface RedirectResponse
 */
export interface RedirectResponse {
    /**
     * 
     * @type {string}
     * @memberof RedirectResponse
     */
    'destination_url': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof RedirectResponse
     */
    'link_id': string;
    /**
     * 
     * @type {object}
     * @memberof RedirectResponse
     */
    'tracking_parameters'?: object;
}
/**
 * Input for reordering options within a field.
 * @export
 * @interface ReorderFieldOptionsInput
 */
export interface ReorderFieldOptionsInput {
    /**
     * 
     * @type {Array<FieldOptionOrderItem>}
     * @memberof ReorderFieldOptionsInput
     */
    'option_order': Array<FieldOptionOrderItem>;
}
/**
 * Response model for field option reordering endpoint.
 * @export
 * @interface ReorderFieldOptionsOutput
 */
export interface ReorderFieldOptionsOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ReorderFieldOptionsOutput
     */
    'field_id': string;
    /**
     * 
     * @type {number}
     * @memberof ReorderFieldOptionsOutput
     */
    'updated_count': number;
}
/**
 * Input for reordering fields within a form.
 * @export
 * @interface ReorderFormFieldsInput
 */
export interface ReorderFormFieldsInput {
    /**
     * 
     * @type {Array<FieldOrderItem>}
     * @memberof ReorderFormFieldsInput
     */
    'field_order': Array<FieldOrderItem>;
}
/**
 * Response model for form field reordering endpoint.
 * @export
 * @interface ReorderFormFieldsOutput
 */
export interface ReorderFormFieldsOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ReorderFormFieldsOutput
     */
    'form_id': string;
    /**
     * 
     * @type {number}
     * @memberof ReorderFormFieldsOutput
     */
    'updated_count': number;
}
/**
 * Whether the field is required.
 * @export
 * @interface RequiredSetting
 */
export interface RequiredSetting {
    /**
     * 
     * @type {string}
     * @memberof RequiredSetting
     */
    'type'?: RequiredSettingTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof RequiredSetting
     */
    'value': boolean;
}

export const RequiredSettingTypeEnum = {
    Required: 'required'
} as const;

export type RequiredSettingTypeEnum = typeof RequiredSettingTypeEnum[keyof typeof RequiredSettingTypeEnum];

/**
 * 
 * @export
 * @interface ReviewFormSubmissionInput
 */
export interface ReviewFormSubmissionInput {
    /**
     * 
     * @type {boolean}
     * @memberof ReviewFormSubmissionInput
     */
    'is_reviewed': boolean;
    /**
     * 
     * @type {string}
     * @memberof ReviewFormSubmissionInput
     */
    'reviewer_notes'?: string;
}
/**
 * Whether the select field has search/filter capability.
 * @export
 * @interface SearchableSetting
 */
export interface SearchableSetting {
    /**
     * 
     * @type {string}
     * @memberof SearchableSetting
     */
    'type'?: SearchableSettingTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SearchableSetting
     */
    'value': boolean;
}

export const SearchableSettingTypeEnum = {
    Searchable: 'searchable'
} as const;

export type SearchableSettingTypeEnum = typeof SearchableSettingTypeEnum[keyof typeof SearchableSettingTypeEnum];

/**
 * A single option for select/multiselect fields.
 * @export
 * @interface SelectOption
 */
export interface SelectOption {
    /**
     * The value to store when this option is selected
     * @type {string}
     * @memberof SelectOption
     */
    'value': string;
    /**
     * The display text shown to the user
     * @type {string}
     * @memberof SelectOption
     */
    'label': string;
    /**
     * Whether this option is disabled
     * @type {boolean}
     * @memberof SelectOption
     */
    'disabled'?: boolean;
}
/**
 * Output model for a selected option in a response.
 * @export
 * @interface SelectedOptionOutput
 */
export interface SelectedOptionOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SelectedOptionOutput
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SelectedOptionOutput
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof SelectedOptionOutput
     */
    'value': string;
    /**
     * 
     * @type {number}
     * @memberof SelectedOptionOutput
     */
    'order_index': number;
}
/**
 * Output model for a status change record.
 * @export
 * @interface StatusChangeOutput
 */
export interface StatusChangeOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof StatusChangeOutput
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof StatusChangeOutput
     */
    'submission_id': string;
    /**
     * 
     * @type {string}
     * @memberof StatusChangeOutput
     */
    'from_status'?: string;
    /**
     * 
     * @type {string}
     * @memberof StatusChangeOutput
     */
    'to_status': string;
    /**
     * 
     * @type {string}
     * @memberof StatusChangeOutput
     */
    'notes'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof StatusChangeOutput
     */
    'changed_by_user_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof StatusChangeOutput
     */
    'created_date': string;
}
/**
 * Output model for a submission with all its field responses.
 * @export
 * @interface SubmissionResponsesOutput
 */
export interface SubmissionResponsesOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SubmissionResponsesOutput
     */
    'submission_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SubmissionResponsesOutput
     */
    'form_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SubmissionResponsesOutput
     */
    'user_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SubmissionResponsesOutput
     */
    'is_reviewed': boolean;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResponsesOutput
     */
    'reviewer_notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResponsesOutput
     */
    'current_status'?: string;
    /**
     * 
     * @type {Array<FormFieldResponseOutput>}
     * @memberof SubmissionResponsesOutput
     */
    'field_responses': Array<FormFieldResponseOutput>;
}
/**
 * Output model for a submission\'s status history.
 * @export
 * @interface SubmissionStatusHistoryOutput
 */
export interface SubmissionStatusHistoryOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof SubmissionStatusHistoryOutput
     */
    'submission_id': string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionStatusHistoryOutput
     */
    'current_status'?: string;
    /**
     * 
     * @type {Array<StatusChangeOutput>}
     * @memberof SubmissionStatusHistoryOutput
     */
    'status_changes': Array<StatusChangeOutput>;
}
/**
 * Input for updating a field option.
 * @export
 * @interface UpdateFieldOptionInput
 */
export interface UpdateFieldOptionInput {
    /**
     * 
     * @type {string}
     * @memberof UpdateFieldOptionInput
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFieldOptionInput
     */
    'value'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateFieldOptionInput
     */
    'order_index'?: number;
}
/**
 * 
 * @export
 * @interface UpdateFieldTemplateInput
 */
export interface UpdateFieldTemplateInput {
    /**
     * 
     * @type {string}
     * @memberof UpdateFieldTemplateInput
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFieldTemplateInput
     */
    'description'?: string;
    /**
     * 
     * @type {FieldType}
     * @memberof UpdateFieldTemplateInput
     */
    'field_type'?: FieldType;
    /**
     * 
     * @type {FieldValueType}
     * @memberof UpdateFieldTemplateInput
     */
    'value_type'?: FieldValueType;
    /**
     * 
     * @type {string}
     * @memberof UpdateFieldTemplateInput
     */
    'default_label'?: string;
    /**
     * 
     * @type {Array<DefaultSettingsInner>}
     * @memberof UpdateFieldTemplateInput
     */
    'default_settings'?: Array<DefaultSettingsInner>;
}


/**
 * 
 * @export
 * @interface UpdateFormFieldInput
 */
export interface UpdateFormFieldInput {
    /**
     * 
     * @type {string}
     * @memberof UpdateFormFieldInput
     */
    'name'?: string;
    /**
     * 
     * @type {FieldType}
     * @memberof UpdateFormFieldInput
     */
    'field_type'?: FieldType;
    /**
     * 
     * @type {FieldValueType}
     * @memberof UpdateFormFieldInput
     */
    'value_type'?: FieldValueType;
    /**
     * 
     * @type {string}
     * @memberof UpdateFormFieldInput
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFormFieldInput
     */
    'help_text'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateFormFieldInput
     */
    'order_index'?: number;
}


/**
 * 
 * @export
 * @interface UpdateFormInput
 */
export interface UpdateFormInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdateFormInput
     */
    'community_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFormInput
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFormInput
     */
    'description'?: string;
    /**
     * 
     * @type {FormType}
     * @memberof UpdateFormInput
     */
    'form_type'?: FormType;
    /**
     * 
     * @type {string}
     * @memberof UpdateFormInput
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFormInput
     */
    'slug'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFormInput
     */
    'is_published'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateFormInput
     */
    'submit_button_text'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFormInput
     */
    'success_message'?: string;
}


/**
 * Input for updating a form submission\'s status.
 * @export
 * @interface UpdateFormSubmissionStatusInput
 */
export interface UpdateFormSubmissionStatusInput {
    /**
     * 
     * @type {ApplicationStatus}
     * @memberof UpdateFormSubmissionStatusInput
     */
    'status': ApplicationStatus;
    /**
     * 
     * @type {string}
     * @memberof UpdateFormSubmissionStatusInput
     */
    'notes'?: string;
}


/**
 * Input for updating a form tag mapping.
 * @export
 * @interface UpdateFormTagMappingInput
 */
export interface UpdateFormTagMappingInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdateFormTagMappingInput
     */
    'field_option_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFormTagMappingInput
     */
    'canonical_tag_id'?: string;
}
/**
 * 
 * @export
 * @interface UpdateLinkInput
 */
export interface UpdateLinkInput {
    /**
     * 
     * @type {string}
     * @memberof UpdateLinkInput
     */
    'original_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLinkInput
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLinkInput
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateLinkInput
     */
    'max_clicks'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateLinkInput
     */
    'expires_at'?: string;
    /**
     * 
     * @type {object}
     * @memberof UpdateLinkInput
     */
    'tracking_parameters'?: object;
}
/**
 * Response model for updating a submission\'s status.
 * @export
 * @interface UpdateSubmissionStatusOutput
 */
export interface UpdateSubmissionStatusOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdateSubmissionStatusOutput
     */
    'submission_id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubmissionStatusOutput
     */
    'from_status'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubmissionStatusOutput
     */
    'to_status': string;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<LocationInner>}
     * @memberof ValidationError
     */
    'loc': Array<LocationInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * Value(s) to compare against. None for is_empty/is_not_empty operators
 * @export
 * @interface Value
 */
export interface Value {
}
/**
 * 
 * @export
 * @interface Value1
 */
export interface Value1 {
}
/**
 * 
 * @export
 * @interface ValueJson
 */
export interface ValueJson {
}

/**
 * FormsApi - axios parameter creator
 * @export
 */
export const FormsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get field responses for multiple form submissions in bulk.
         * @summary Bulk Get Submission Responses
         * @param {BulkGetSubmissionResponsesInput} bulkGetSubmissionResponsesInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetSubmissionResponsesFormsSubmissionsResponsesBulkPost: async (bulkGetSubmissionResponsesInput: BulkGetSubmissionResponsesInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkGetSubmissionResponsesInput' is not null or undefined
            assertParamExists('bulkGetSubmissionResponsesFormsSubmissionsResponsesBulkPost', 'bulkGetSubmissionResponsesInput', bulkGetSubmissionResponsesInput)
            const localVarPath = `/forms/submissions/responses/bulk/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkGetSubmissionResponsesInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new field option.
         * @summary Create Field Option
         * @param {CreateFieldOptionInput} createFieldOptionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFieldOptionFormsOptionsPost: async (createFieldOptionInput: CreateFieldOptionInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFieldOptionInput' is not null or undefined
            assertParamExists('createFieldOptionFormsOptionsPost', 'createFieldOptionInput', createFieldOptionInput)
            const localVarPath = `/forms/options/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFieldOptionInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new field template.
         * @summary Create Field Template
         * @param {CreateFieldTemplateInput} createFieldTemplateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFieldTemplateFormsTemplatesPost: async (createFieldTemplateInput: CreateFieldTemplateInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFieldTemplateInput' is not null or undefined
            assertParamExists('createFieldTemplateFormsTemplatesPost', 'createFieldTemplateInput', createFieldTemplateInput)
            const localVarPath = `/forms/templates/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFieldTemplateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new form field.
         * @summary Create Form Field
         * @param {CreateFormFieldInput} createFormFieldInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFormFieldFormsFieldsPost: async (createFormFieldInput: CreateFormFieldInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFormFieldInput' is not null or undefined
            assertParamExists('createFormFieldFormsFieldsPost', 'createFormFieldInput', createFormFieldInput)
            const localVarPath = `/forms/fields/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFormFieldInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new form.
         * @summary Create Form
         * @param {CreateFormInput} createFormInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFormFormsPost: async (createFormInput: CreateFormInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFormInput' is not null or undefined
            assertParamExists('createFormFormsPost', 'createFormInput', createFormInput)
            const localVarPath = `/forms/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFormInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new form submission (public endpoint).
         * @summary Create Form Submission
         * @param {CreateFormSubmissionInput} createFormSubmissionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFormSubmissionFormsSubmissionsPost: async (createFormSubmissionInput: CreateFormSubmissionInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFormSubmissionInput' is not null or undefined
            assertParamExists('createFormSubmissionFormsSubmissionsPost', 'createFormSubmissionInput', createFormSubmissionInput)
            const localVarPath = `/forms/submissions/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFormSubmissionInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new form tag mapping.
         * @summary Create Form Tag Mapping
         * @param {CreateFormTagMappingInput} createFormTagMappingInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFormTagMappingFormsTagMappingsPost: async (createFormTagMappingInput: CreateFormTagMappingInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFormTagMappingInput' is not null or undefined
            assertParamExists('createFormTagMappingFormsTagMappingsPost', 'createFormTagMappingInput', createFormTagMappingInput)
            const localVarPath = `/forms/tag-mappings/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFormTagMappingInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a field option.
         * @summary Delete Field Option
         * @param {string} optionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFieldOptionFormsOptionsOptionIdDelete: async (optionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'optionId' is not null or undefined
            assertParamExists('deleteFieldOptionFormsOptionsOptionIdDelete', 'optionId', optionId)
            const localVarPath = `/forms/options/{option_id}/`
                .replace(`{${"option_id"}}`, encodeURIComponent(String(optionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a field template.
         * @summary Delete Field Template
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFieldTemplateFormsTemplatesTemplateIdDelete: async (templateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('deleteFieldTemplateFormsTemplatesTemplateIdDelete', 'templateId', templateId)
            const localVarPath = `/forms/templates/{template_id}/`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a form field.
         * @summary Delete Form Field
         * @param {string} fieldId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFormFieldFormsFieldsFieldIdDelete: async (fieldId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fieldId' is not null or undefined
            assertParamExists('deleteFormFieldFormsFieldsFieldIdDelete', 'fieldId', fieldId)
            const localVarPath = `/forms/fields/{field_id}/`
                .replace(`{${"field_id"}}`, encodeURIComponent(String(fieldId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a form.
         * @summary Delete Form
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFormFormsFormIdDelete: async (formId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('deleteFormFormsFormIdDelete', 'formId', formId)
            const localVarPath = `/forms/{form_id}/`
                .replace(`{${"form_id"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a form submission.
         * @summary Delete Form Submission
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFormSubmissionFormsSubmissionsSubmissionIdDelete: async (submissionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('deleteFormSubmissionFormsSubmissionsSubmissionIdDelete', 'submissionId', submissionId)
            const localVarPath = `/forms/submissions/{submission_id}/`
                .replace(`{${"submission_id"}}`, encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a form tag mapping.
         * @summary Delete Form Tag Mapping
         * @param {string} mappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFormTagMappingFormsTagMappingsMappingIdDelete: async (mappingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mappingId' is not null or undefined
            assertParamExists('deleteFormTagMappingFormsTagMappingsMappingIdDelete', 'mappingId', mappingId)
            const localVarPath = `/forms/tag-mappings/{mapping_id}/`
                .replace(`{${"mapping_id"}}`, encodeURIComponent(String(mappingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a field option by ID.
         * @summary Get Field Option
         * @param {string} optionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFieldOptionFormsOptionsOptionIdGet: async (optionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'optionId' is not null or undefined
            assertParamExists('getFieldOptionFormsOptionsOptionIdGet', 'optionId', optionId)
            const localVarPath = `/forms/options/{option_id}/`
                .replace(`{${"option_id"}}`, encodeURIComponent(String(optionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a field template by ID.
         * @summary Get Field Template
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFieldTemplateFormsTemplatesTemplateIdGet: async (templateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('getFieldTemplateFormsTemplatesTemplateIdGet', 'templateId', templateId)
            const localVarPath = `/forms/templates/{template_id}/`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a form by slug (public endpoint for form display).
         * @summary Get Form By Slug
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormBySlugFormsSlugSlugGet: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('getFormBySlugFormsSlugSlugGet', 'slug', slug)
            const localVarPath = `/forms/slug/{slug}/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a form field by ID.
         * @summary Get Form Field
         * @param {string} fieldId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormFieldFormsFieldsFieldIdGet: async (fieldId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fieldId' is not null or undefined
            assertParamExists('getFormFieldFormsFieldsFieldIdGet', 'fieldId', fieldId)
            const localVarPath = `/forms/fields/{field_id}/`
                .replace(`{${"field_id"}}`, encodeURIComponent(String(fieldId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a form by ID.
         * @summary Get Form
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormFormsFormIdGet: async (formId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('getFormFormsFormIdGet', 'formId', formId)
            const localVarPath = `/forms/{form_id}/`
                .replace(`{${"form_id"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a form submission by ID.
         * @summary Get Form Submission
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormSubmissionFormsSubmissionsSubmissionIdGet: async (submissionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('getFormSubmissionFormsSubmissionsSubmissionIdGet', 'submissionId', submissionId)
            const localVarPath = `/forms/submissions/{submission_id}/`
                .replace(`{${"submission_id"}}`, encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a form tag mapping by ID.
         * @summary Get Form Tag Mapping
         * @param {string} mappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormTagMappingFormsTagMappingsMappingIdGet: async (mappingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mappingId' is not null or undefined
            assertParamExists('getFormTagMappingFormsTagMappingsMappingIdGet', 'mappingId', mappingId)
            const localVarPath = `/forms/tag-mappings/{mapping_id}/`
                .replace(`{${"mapping_id"}}`, encodeURIComponent(String(mappingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all field responses for a specific form submission.
         * @summary Get Submission Responses
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubmissionResponsesFormsSubmissionsSubmissionIdResponsesGet: async (submissionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('getSubmissionResponsesFormsSubmissionsSubmissionIdResponsesGet', 'submissionId', submissionId)
            const localVarPath = `/forms/submissions/{submission_id}/responses/`
                .replace(`{${"submission_id"}}`, encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the status change history for a form submission.
         * @summary Get Submission Status History
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubmissionStatusHistoryFormsSubmissionsSubmissionIdStatusHistoryGet: async (submissionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('getSubmissionStatusHistoryFormsSubmissionsSubmissionIdStatusHistoryGet', 'submissionId', submissionId)
            const localVarPath = `/forms/submissions/{submission_id}/status-history/`
                .replace(`{${"submission_id"}}`, encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all options for a field (public endpoint).
         * @summary List Field Options
         * @param {string} fieldId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFieldOptionsFormsFieldsFieldIdOptionsGet: async (fieldId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fieldId' is not null or undefined
            assertParamExists('listFieldOptionsFormsFieldsFieldIdOptionsGet', 'fieldId', fieldId)
            const localVarPath = `/forms/fields/{field_id}/options/`
                .replace(`{${"field_id"}}`, encodeURIComponent(String(fieldId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all field templates.
         * @summary List Field Templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFieldTemplatesFormsTemplatesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/forms/templates/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all fields for a form (public endpoint).
         * @summary List Form Fields
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFormFieldsFormsFormIdFieldsGet: async (formId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('listFormFieldsFormsFormIdFieldsGet', 'formId', formId)
            const localVarPath = `/forms/{form_id}/fields/`
                .replace(`{${"form_id"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all submissions for a form.
         * @summary List Form Submissions
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFormSubmissionsFormsFormIdSubmissionsGet: async (formId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('listFormSubmissionsFormsFormIdSubmissionsGet', 'formId', formId)
            const localVarPath = `/forms/{form_id}/submissions/`
                .replace(`{${"form_id"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all tag mappings for a specific form.
         * @summary List Form Tag Mappings
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFormTagMappingsFormsFormIdTagMappingsGet: async (formId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('listFormTagMappingsFormsFormIdTagMappingsGet', 'formId', formId)
            const localVarPath = `/forms/{form_id}/tag-mappings/`
                .replace(`{${"form_id"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all forms for a community.
         * @summary List Forms
         * @param {string} communityId 
         * @param {boolean} [publishedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFormsFormsCommunitiesCommunityIdGet: async (communityId: string, publishedOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('listFormsFormsCommunitiesCommunityIdGet', 'communityId', communityId)
            const localVarPath = `/forms/communities/{community_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (publishedOnly !== undefined) {
                localVarQueryParameter['published_only'] = publishedOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reorder options within a field.  Uses bulk update in transaction (Option 1 pattern) to avoid unique constraint violations during reordering. All updates happen atomically.  Security: Validates that all option_ids belong to the specified field_id.
         * @summary Reorder Field Options
         * @param {string} fieldId 
         * @param {ReorderFieldOptionsInput} reorderFieldOptionsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderFieldOptionsFormsFieldsFieldIdOptionsReorderPost: async (fieldId: string, reorderFieldOptionsInput: ReorderFieldOptionsInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fieldId' is not null or undefined
            assertParamExists('reorderFieldOptionsFormsFieldsFieldIdOptionsReorderPost', 'fieldId', fieldId)
            // verify required parameter 'reorderFieldOptionsInput' is not null or undefined
            assertParamExists('reorderFieldOptionsFormsFieldsFieldIdOptionsReorderPost', 'reorderFieldOptionsInput', reorderFieldOptionsInput)
            const localVarPath = `/forms/fields/{field_id}/options/reorder/`
                .replace(`{${"field_id"}}`, encodeURIComponent(String(fieldId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reorderFieldOptionsInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reorder fields within a form.
         * @summary Reorder Form Fields
         * @param {string} formId 
         * @param {ReorderFormFieldsInput} reorderFormFieldsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderFormFieldsFormsFormIdFieldsReorderPost: async (formId: string, reorderFormFieldsInput: ReorderFormFieldsInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('reorderFormFieldsFormsFormIdFieldsReorderPost', 'formId', formId)
            // verify required parameter 'reorderFormFieldsInput' is not null or undefined
            assertParamExists('reorderFormFieldsFormsFormIdFieldsReorderPost', 'reorderFormFieldsInput', reorderFormFieldsInput)
            const localVarPath = `/forms/{form_id}/fields/reorder/`
                .replace(`{${"form_id"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reorderFormFieldsInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Review a form submission.
         * @summary Review Form Submission
         * @param {string} submissionId 
         * @param {ReviewFormSubmissionInput} reviewFormSubmissionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewFormSubmissionFormsSubmissionsSubmissionIdReviewPatch: async (submissionId: string, reviewFormSubmissionInput: ReviewFormSubmissionInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('reviewFormSubmissionFormsSubmissionsSubmissionIdReviewPatch', 'submissionId', submissionId)
            // verify required parameter 'reviewFormSubmissionInput' is not null or undefined
            assertParamExists('reviewFormSubmissionFormsSubmissionsSubmissionIdReviewPatch', 'reviewFormSubmissionInput', reviewFormSubmissionInput)
            const localVarPath = `/forms/submissions/{submission_id}/review/`
                .replace(`{${"submission_id"}}`, encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewFormSubmissionInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a field option.
         * @summary Update Field Option
         * @param {string} optionId 
         * @param {UpdateFieldOptionInput} updateFieldOptionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFieldOptionFormsOptionsOptionIdPut: async (optionId: string, updateFieldOptionInput: UpdateFieldOptionInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'optionId' is not null or undefined
            assertParamExists('updateFieldOptionFormsOptionsOptionIdPut', 'optionId', optionId)
            // verify required parameter 'updateFieldOptionInput' is not null or undefined
            assertParamExists('updateFieldOptionFormsOptionsOptionIdPut', 'updateFieldOptionInput', updateFieldOptionInput)
            const localVarPath = `/forms/options/{option_id}/`
                .replace(`{${"option_id"}}`, encodeURIComponent(String(optionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFieldOptionInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a field template.
         * @summary Update Field Template
         * @param {string} templateId 
         * @param {UpdateFieldTemplateInput} updateFieldTemplateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFieldTemplateFormsTemplatesTemplateIdPut: async (templateId: string, updateFieldTemplateInput: UpdateFieldTemplateInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('updateFieldTemplateFormsTemplatesTemplateIdPut', 'templateId', templateId)
            // verify required parameter 'updateFieldTemplateInput' is not null or undefined
            assertParamExists('updateFieldTemplateFormsTemplatesTemplateIdPut', 'updateFieldTemplateInput', updateFieldTemplateInput)
            const localVarPath = `/forms/templates/{template_id}/`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFieldTemplateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a form field.
         * @summary Update Form Field
         * @param {string} fieldId 
         * @param {UpdateFormFieldInput} updateFormFieldInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFormFieldFormsFieldsFieldIdPut: async (fieldId: string, updateFormFieldInput: UpdateFormFieldInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fieldId' is not null or undefined
            assertParamExists('updateFormFieldFormsFieldsFieldIdPut', 'fieldId', fieldId)
            // verify required parameter 'updateFormFieldInput' is not null or undefined
            assertParamExists('updateFormFieldFormsFieldsFieldIdPut', 'updateFormFieldInput', updateFormFieldInput)
            const localVarPath = `/forms/fields/{field_id}/`
                .replace(`{${"field_id"}}`, encodeURIComponent(String(fieldId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFormFieldInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a form.
         * @summary Update Form
         * @param {string} formId 
         * @param {UpdateFormInput} updateFormInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFormFormsFormIdPut: async (formId: string, updateFormInput: UpdateFormInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('updateFormFormsFormIdPut', 'formId', formId)
            // verify required parameter 'updateFormInput' is not null or undefined
            assertParamExists('updateFormFormsFormIdPut', 'updateFormInput', updateFormInput)
            const localVarPath = `/forms/{form_id}/`
                .replace(`{${"form_id"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFormInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a form tag mapping.
         * @summary Update Form Tag Mapping
         * @param {string} mappingId 
         * @param {UpdateFormTagMappingInput} updateFormTagMappingInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFormTagMappingFormsTagMappingsMappingIdPut: async (mappingId: string, updateFormTagMappingInput: UpdateFormTagMappingInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mappingId' is not null or undefined
            assertParamExists('updateFormTagMappingFormsTagMappingsMappingIdPut', 'mappingId', mappingId)
            // verify required parameter 'updateFormTagMappingInput' is not null or undefined
            assertParamExists('updateFormTagMappingFormsTagMappingsMappingIdPut', 'updateFormTagMappingInput', updateFormTagMappingInput)
            const localVarPath = `/forms/tag-mappings/{mapping_id}/`
                .replace(`{${"mapping_id"}}`, encodeURIComponent(String(mappingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFormTagMappingInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the status of an application form submission.
         * @summary Update Submission Status
         * @param {string} submissionId 
         * @param {UpdateFormSubmissionStatusInput} updateFormSubmissionStatusInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubmissionStatusFormsSubmissionsSubmissionIdStatusPatch: async (submissionId: string, updateFormSubmissionStatusInput: UpdateFormSubmissionStatusInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('updateSubmissionStatusFormsSubmissionsSubmissionIdStatusPatch', 'submissionId', submissionId)
            // verify required parameter 'updateFormSubmissionStatusInput' is not null or undefined
            assertParamExists('updateSubmissionStatusFormsSubmissionsSubmissionIdStatusPatch', 'updateFormSubmissionStatusInput', updateFormSubmissionStatusInput)
            const localVarPath = `/forms/submissions/{submission_id}/status/`
                .replace(`{${"submission_id"}}`, encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFormSubmissionStatusInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FormsApi - functional programming interface
 * @export
 */
export const FormsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FormsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get field responses for multiple form submissions in bulk.
         * @summary Bulk Get Submission Responses
         * @param {BulkGetSubmissionResponsesInput} bulkGetSubmissionResponsesInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetSubmissionResponsesFormsSubmissionsResponsesBulkPost(bulkGetSubmissionResponsesInput: BulkGetSubmissionResponsesInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SubmissionResponsesOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetSubmissionResponsesFormsSubmissionsResponsesBulkPost(bulkGetSubmissionResponsesInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.bulkGetSubmissionResponsesFormsSubmissionsResponsesBulkPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Create a new field option.
         * @summary Create Field Option
         * @param {CreateFieldOptionInput} createFieldOptionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFieldOptionFormsOptionsPost(createFieldOptionInput: CreateFieldOptionInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FieldOption>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFieldOptionFormsOptionsPost(createFieldOptionInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.createFieldOptionFormsOptionsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Create a new field template.
         * @summary Create Field Template
         * @param {CreateFieldTemplateInput} createFieldTemplateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFieldTemplateFormsTemplatesPost(createFieldTemplateInput: CreateFieldTemplateInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FieldTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFieldTemplateFormsTemplatesPost(createFieldTemplateInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.createFieldTemplateFormsTemplatesPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Create a new form field.
         * @summary Create Form Field
         * @param {CreateFormFieldInput} createFormFieldInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFormFieldFormsFieldsPost(createFormFieldInput: CreateFormFieldInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormField>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFormFieldFormsFieldsPost(createFormFieldInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.createFormFieldFormsFieldsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Create a new form.
         * @summary Create Form
         * @param {CreateFormInput} createFormInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFormFormsPost(createFormInput: CreateFormInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Form>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFormFormsPost(createFormInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.createFormFormsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Create a new form submission (public endpoint).
         * @summary Create Form Submission
         * @param {CreateFormSubmissionInput} createFormSubmissionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFormSubmissionFormsSubmissionsPost(createFormSubmissionInput: CreateFormSubmissionInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormSubmission>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFormSubmissionFormsSubmissionsPost(createFormSubmissionInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.createFormSubmissionFormsSubmissionsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Create a new form tag mapping.
         * @summary Create Form Tag Mapping
         * @param {CreateFormTagMappingInput} createFormTagMappingInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFormTagMappingFormsTagMappingsPost(createFormTagMappingInput: CreateFormTagMappingInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormTagMapping>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFormTagMappingFormsTagMappingsPost(createFormTagMappingInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.createFormTagMappingFormsTagMappingsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Delete a field option.
         * @summary Delete Field Option
         * @param {string} optionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFieldOptionFormsOptionsOptionIdDelete(optionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteFieldOptionOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFieldOptionFormsOptionsOptionIdDelete(optionId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.deleteFieldOptionFormsOptionsOptionIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Delete a field template.
         * @summary Delete Field Template
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFieldTemplateFormsTemplatesTemplateIdDelete(templateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteFieldTemplateOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFieldTemplateFormsTemplatesTemplateIdDelete(templateId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.deleteFieldTemplateFormsTemplatesTemplateIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Delete a form field.
         * @summary Delete Form Field
         * @param {string} fieldId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFormFieldFormsFieldsFieldIdDelete(fieldId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteFormFieldOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFormFieldFormsFieldsFieldIdDelete(fieldId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.deleteFormFieldFormsFieldsFieldIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Delete a form.
         * @summary Delete Form
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFormFormsFormIdDelete(formId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteFormOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFormFormsFormIdDelete(formId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.deleteFormFormsFormIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Delete a form submission.
         * @summary Delete Form Submission
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFormSubmissionFormsSubmissionsSubmissionIdDelete(submissionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteFormSubmissionOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFormSubmissionFormsSubmissionsSubmissionIdDelete(submissionId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.deleteFormSubmissionFormsSubmissionsSubmissionIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Delete a form tag mapping.
         * @summary Delete Form Tag Mapping
         * @param {string} mappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFormTagMappingFormsTagMappingsMappingIdDelete(mappingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteFormTagMappingOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFormTagMappingFormsTagMappingsMappingIdDelete(mappingId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.deleteFormTagMappingFormsTagMappingsMappingIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get a field option by ID.
         * @summary Get Field Option
         * @param {string} optionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFieldOptionFormsOptionsOptionIdGet(optionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FieldOption>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFieldOptionFormsOptionsOptionIdGet(optionId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.getFieldOptionFormsOptionsOptionIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get a field template by ID.
         * @summary Get Field Template
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFieldTemplateFormsTemplatesTemplateIdGet(templateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FieldTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFieldTemplateFormsTemplatesTemplateIdGet(templateId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.getFieldTemplateFormsTemplatesTemplateIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get a form by slug (public endpoint for form display).
         * @summary Get Form By Slug
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFormBySlugFormsSlugSlugGet(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Form>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFormBySlugFormsSlugSlugGet(slug, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.getFormBySlugFormsSlugSlugGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get a form field by ID.
         * @summary Get Form Field
         * @param {string} fieldId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFormFieldFormsFieldsFieldIdGet(fieldId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormField>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFormFieldFormsFieldsFieldIdGet(fieldId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.getFormFieldFormsFieldsFieldIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get a form by ID.
         * @summary Get Form
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFormFormsFormIdGet(formId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Form>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFormFormsFormIdGet(formId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.getFormFormsFormIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get a form submission by ID.
         * @summary Get Form Submission
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFormSubmissionFormsSubmissionsSubmissionIdGet(submissionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormSubmission>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFormSubmissionFormsSubmissionsSubmissionIdGet(submissionId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.getFormSubmissionFormsSubmissionsSubmissionIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get a form tag mapping by ID.
         * @summary Get Form Tag Mapping
         * @param {string} mappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFormTagMappingFormsTagMappingsMappingIdGet(mappingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormTagMapping>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFormTagMappingFormsTagMappingsMappingIdGet(mappingId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.getFormTagMappingFormsTagMappingsMappingIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all field responses for a specific form submission.
         * @summary Get Submission Responses
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubmissionResponsesFormsSubmissionsSubmissionIdResponsesGet(submissionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionResponsesOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubmissionResponsesFormsSubmissionsSubmissionIdResponsesGet(submissionId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.getSubmissionResponsesFormsSubmissionsSubmissionIdResponsesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get the status change history for a form submission.
         * @summary Get Submission Status History
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubmissionStatusHistoryFormsSubmissionsSubmissionIdStatusHistoryGet(submissionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionStatusHistoryOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubmissionStatusHistoryFormsSubmissionsSubmissionIdStatusHistoryGet(submissionId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.getSubmissionStatusHistoryFormsSubmissionsSubmissionIdStatusHistoryGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List all options for a field (public endpoint).
         * @summary List Field Options
         * @param {string} fieldId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFieldOptionsFormsFieldsFieldIdOptionsGet(fieldId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FieldOption>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFieldOptionsFormsFieldsFieldIdOptionsGet(fieldId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.listFieldOptionsFormsFieldsFieldIdOptionsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List all field templates.
         * @summary List Field Templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFieldTemplatesFormsTemplatesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FieldTemplate>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFieldTemplatesFormsTemplatesGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.listFieldTemplatesFormsTemplatesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List all fields for a form (public endpoint).
         * @summary List Form Fields
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFormFieldsFormsFormIdFieldsGet(formId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FormField>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFormFieldsFormsFormIdFieldsGet(formId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.listFormFieldsFormsFormIdFieldsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List all submissions for a form.
         * @summary List Form Submissions
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFormSubmissionsFormsFormIdSubmissionsGet(formId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FormSubmission>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFormSubmissionsFormsFormIdSubmissionsGet(formId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.listFormSubmissionsFormsFormIdSubmissionsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List all tag mappings for a specific form.
         * @summary List Form Tag Mappings
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFormTagMappingsFormsFormIdTagMappingsGet(formId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FormTagMapping>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFormTagMappingsFormsFormIdTagMappingsGet(formId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.listFormTagMappingsFormsFormIdTagMappingsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List all forms for a community.
         * @summary List Forms
         * @param {string} communityId 
         * @param {boolean} [publishedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFormsFormsCommunitiesCommunityIdGet(communityId: string, publishedOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Form>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFormsFormsCommunitiesCommunityIdGet(communityId, publishedOnly, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.listFormsFormsCommunitiesCommunityIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Reorder options within a field.  Uses bulk update in transaction (Option 1 pattern) to avoid unique constraint violations during reordering. All updates happen atomically.  Security: Validates that all option_ids belong to the specified field_id.
         * @summary Reorder Field Options
         * @param {string} fieldId 
         * @param {ReorderFieldOptionsInput} reorderFieldOptionsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorderFieldOptionsFormsFieldsFieldIdOptionsReorderPost(fieldId: string, reorderFieldOptionsInput: ReorderFieldOptionsInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReorderFieldOptionsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorderFieldOptionsFormsFieldsFieldIdOptionsReorderPost(fieldId, reorderFieldOptionsInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.reorderFieldOptionsFormsFieldsFieldIdOptionsReorderPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Reorder fields within a form.
         * @summary Reorder Form Fields
         * @param {string} formId 
         * @param {ReorderFormFieldsInput} reorderFormFieldsInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorderFormFieldsFormsFormIdFieldsReorderPost(formId: string, reorderFormFieldsInput: ReorderFormFieldsInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReorderFormFieldsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorderFormFieldsFormsFormIdFieldsReorderPost(formId, reorderFormFieldsInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.reorderFormFieldsFormsFormIdFieldsReorderPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Review a form submission.
         * @summary Review Form Submission
         * @param {string} submissionId 
         * @param {ReviewFormSubmissionInput} reviewFormSubmissionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewFormSubmissionFormsSubmissionsSubmissionIdReviewPatch(submissionId: string, reviewFormSubmissionInput: ReviewFormSubmissionInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormSubmission>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewFormSubmissionFormsSubmissionsSubmissionIdReviewPatch(submissionId, reviewFormSubmissionInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.reviewFormSubmissionFormsSubmissionsSubmissionIdReviewPatch']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update a field option.
         * @summary Update Field Option
         * @param {string} optionId 
         * @param {UpdateFieldOptionInput} updateFieldOptionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFieldOptionFormsOptionsOptionIdPut(optionId: string, updateFieldOptionInput: UpdateFieldOptionInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FieldOption>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFieldOptionFormsOptionsOptionIdPut(optionId, updateFieldOptionInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.updateFieldOptionFormsOptionsOptionIdPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update a field template.
         * @summary Update Field Template
         * @param {string} templateId 
         * @param {UpdateFieldTemplateInput} updateFieldTemplateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFieldTemplateFormsTemplatesTemplateIdPut(templateId: string, updateFieldTemplateInput: UpdateFieldTemplateInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FieldTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFieldTemplateFormsTemplatesTemplateIdPut(templateId, updateFieldTemplateInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.updateFieldTemplateFormsTemplatesTemplateIdPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update a form field.
         * @summary Update Form Field
         * @param {string} fieldId 
         * @param {UpdateFormFieldInput} updateFormFieldInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFormFieldFormsFieldsFieldIdPut(fieldId: string, updateFormFieldInput: UpdateFormFieldInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormField>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFormFieldFormsFieldsFieldIdPut(fieldId, updateFormFieldInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.updateFormFieldFormsFieldsFieldIdPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update a form.
         * @summary Update Form
         * @param {string} formId 
         * @param {UpdateFormInput} updateFormInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFormFormsFormIdPut(formId: string, updateFormInput: UpdateFormInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Form>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFormFormsFormIdPut(formId, updateFormInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.updateFormFormsFormIdPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update a form tag mapping.
         * @summary Update Form Tag Mapping
         * @param {string} mappingId 
         * @param {UpdateFormTagMappingInput} updateFormTagMappingInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFormTagMappingFormsTagMappingsMappingIdPut(mappingId: string, updateFormTagMappingInput: UpdateFormTagMappingInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormTagMapping>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFormTagMappingFormsTagMappingsMappingIdPut(mappingId, updateFormTagMappingInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.updateFormTagMappingFormsTagMappingsMappingIdPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update the status of an application form submission.
         * @summary Update Submission Status
         * @param {string} submissionId 
         * @param {UpdateFormSubmissionStatusInput} updateFormSubmissionStatusInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSubmissionStatusFormsSubmissionsSubmissionIdStatusPatch(submissionId: string, updateFormSubmissionStatusInput: UpdateFormSubmissionStatusInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateSubmissionStatusOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSubmissionStatusFormsSubmissionsSubmissionIdStatusPatch(submissionId, updateFormSubmissionStatusInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FormsApi.updateSubmissionStatusFormsSubmissionsSubmissionIdStatusPatch']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * FormsApi - factory interface
 * @export
 */
export const FormsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FormsApiFp(configuration)
    return {
        /**
         * Get field responses for multiple form submissions in bulk.
         * @summary Bulk Get Submission Responses
         * @param {FormsApiBulkGetSubmissionResponsesFormsSubmissionsResponsesBulkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetSubmissionResponsesFormsSubmissionsResponsesBulkPost(requestParameters: FormsApiBulkGetSubmissionResponsesFormsSubmissionsResponsesBulkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SubmissionResponsesOutput>> {
            return localVarFp.bulkGetSubmissionResponsesFormsSubmissionsResponsesBulkPost(requestParameters.bulkGetSubmissionResponsesInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new field option.
         * @summary Create Field Option
         * @param {FormsApiCreateFieldOptionFormsOptionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFieldOptionFormsOptionsPost(requestParameters: FormsApiCreateFieldOptionFormsOptionsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<FieldOption> {
            return localVarFp.createFieldOptionFormsOptionsPost(requestParameters.createFieldOptionInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new field template.
         * @summary Create Field Template
         * @param {FormsApiCreateFieldTemplateFormsTemplatesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFieldTemplateFormsTemplatesPost(requestParameters: FormsApiCreateFieldTemplateFormsTemplatesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<FieldTemplate> {
            return localVarFp.createFieldTemplateFormsTemplatesPost(requestParameters.createFieldTemplateInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new form field.
         * @summary Create Form Field
         * @param {FormsApiCreateFormFieldFormsFieldsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFormFieldFormsFieldsPost(requestParameters: FormsApiCreateFormFieldFormsFieldsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormField> {
            return localVarFp.createFormFieldFormsFieldsPost(requestParameters.createFormFieldInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new form.
         * @summary Create Form
         * @param {FormsApiCreateFormFormsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFormFormsPost(requestParameters: FormsApiCreateFormFormsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Form> {
            return localVarFp.createFormFormsPost(requestParameters.createFormInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new form submission (public endpoint).
         * @summary Create Form Submission
         * @param {FormsApiCreateFormSubmissionFormsSubmissionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFormSubmissionFormsSubmissionsPost(requestParameters: FormsApiCreateFormSubmissionFormsSubmissionsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormSubmission> {
            return localVarFp.createFormSubmissionFormsSubmissionsPost(requestParameters.createFormSubmissionInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new form tag mapping.
         * @summary Create Form Tag Mapping
         * @param {FormsApiCreateFormTagMappingFormsTagMappingsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFormTagMappingFormsTagMappingsPost(requestParameters: FormsApiCreateFormTagMappingFormsTagMappingsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormTagMapping> {
            return localVarFp.createFormTagMappingFormsTagMappingsPost(requestParameters.createFormTagMappingInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a field option.
         * @summary Delete Field Option
         * @param {FormsApiDeleteFieldOptionFormsOptionsOptionIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFieldOptionFormsOptionsOptionIdDelete(requestParameters: FormsApiDeleteFieldOptionFormsOptionsOptionIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteFieldOptionOutput> {
            return localVarFp.deleteFieldOptionFormsOptionsOptionIdDelete(requestParameters.optionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a field template.
         * @summary Delete Field Template
         * @param {FormsApiDeleteFieldTemplateFormsTemplatesTemplateIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFieldTemplateFormsTemplatesTemplateIdDelete(requestParameters: FormsApiDeleteFieldTemplateFormsTemplatesTemplateIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteFieldTemplateOutput> {
            return localVarFp.deleteFieldTemplateFormsTemplatesTemplateIdDelete(requestParameters.templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a form field.
         * @summary Delete Form Field
         * @param {FormsApiDeleteFormFieldFormsFieldsFieldIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFormFieldFormsFieldsFieldIdDelete(requestParameters: FormsApiDeleteFormFieldFormsFieldsFieldIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteFormFieldOutput> {
            return localVarFp.deleteFormFieldFormsFieldsFieldIdDelete(requestParameters.fieldId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a form.
         * @summary Delete Form
         * @param {FormsApiDeleteFormFormsFormIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFormFormsFormIdDelete(requestParameters: FormsApiDeleteFormFormsFormIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteFormOutput> {
            return localVarFp.deleteFormFormsFormIdDelete(requestParameters.formId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a form submission.
         * @summary Delete Form Submission
         * @param {FormsApiDeleteFormSubmissionFormsSubmissionsSubmissionIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFormSubmissionFormsSubmissionsSubmissionIdDelete(requestParameters: FormsApiDeleteFormSubmissionFormsSubmissionsSubmissionIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteFormSubmissionOutput> {
            return localVarFp.deleteFormSubmissionFormsSubmissionsSubmissionIdDelete(requestParameters.submissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a form tag mapping.
         * @summary Delete Form Tag Mapping
         * @param {FormsApiDeleteFormTagMappingFormsTagMappingsMappingIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFormTagMappingFormsTagMappingsMappingIdDelete(requestParameters: FormsApiDeleteFormTagMappingFormsTagMappingsMappingIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteFormTagMappingOutput> {
            return localVarFp.deleteFormTagMappingFormsTagMappingsMappingIdDelete(requestParameters.mappingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a field option by ID.
         * @summary Get Field Option
         * @param {FormsApiGetFieldOptionFormsOptionsOptionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFieldOptionFormsOptionsOptionIdGet(requestParameters: FormsApiGetFieldOptionFormsOptionsOptionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<FieldOption> {
            return localVarFp.getFieldOptionFormsOptionsOptionIdGet(requestParameters.optionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a field template by ID.
         * @summary Get Field Template
         * @param {FormsApiGetFieldTemplateFormsTemplatesTemplateIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFieldTemplateFormsTemplatesTemplateIdGet(requestParameters: FormsApiGetFieldTemplateFormsTemplatesTemplateIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<FieldTemplate> {
            return localVarFp.getFieldTemplateFormsTemplatesTemplateIdGet(requestParameters.templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a form by slug (public endpoint for form display).
         * @summary Get Form By Slug
         * @param {FormsApiGetFormBySlugFormsSlugSlugGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormBySlugFormsSlugSlugGet(requestParameters: FormsApiGetFormBySlugFormsSlugSlugGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Form> {
            return localVarFp.getFormBySlugFormsSlugSlugGet(requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a form field by ID.
         * @summary Get Form Field
         * @param {FormsApiGetFormFieldFormsFieldsFieldIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormFieldFormsFieldsFieldIdGet(requestParameters: FormsApiGetFormFieldFormsFieldsFieldIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormField> {
            return localVarFp.getFormFieldFormsFieldsFieldIdGet(requestParameters.fieldId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a form by ID.
         * @summary Get Form
         * @param {FormsApiGetFormFormsFormIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormFormsFormIdGet(requestParameters: FormsApiGetFormFormsFormIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Form> {
            return localVarFp.getFormFormsFormIdGet(requestParameters.formId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a form submission by ID.
         * @summary Get Form Submission
         * @param {FormsApiGetFormSubmissionFormsSubmissionsSubmissionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormSubmissionFormsSubmissionsSubmissionIdGet(requestParameters: FormsApiGetFormSubmissionFormsSubmissionsSubmissionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormSubmission> {
            return localVarFp.getFormSubmissionFormsSubmissionsSubmissionIdGet(requestParameters.submissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a form tag mapping by ID.
         * @summary Get Form Tag Mapping
         * @param {FormsApiGetFormTagMappingFormsTagMappingsMappingIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormTagMappingFormsTagMappingsMappingIdGet(requestParameters: FormsApiGetFormTagMappingFormsTagMappingsMappingIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormTagMapping> {
            return localVarFp.getFormTagMappingFormsTagMappingsMappingIdGet(requestParameters.mappingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all field responses for a specific form submission.
         * @summary Get Submission Responses
         * @param {FormsApiGetSubmissionResponsesFormsSubmissionsSubmissionIdResponsesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubmissionResponsesFormsSubmissionsSubmissionIdResponsesGet(requestParameters: FormsApiGetSubmissionResponsesFormsSubmissionsSubmissionIdResponsesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionResponsesOutput> {
            return localVarFp.getSubmissionResponsesFormsSubmissionsSubmissionIdResponsesGet(requestParameters.submissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the status change history for a form submission.
         * @summary Get Submission Status History
         * @param {FormsApiGetSubmissionStatusHistoryFormsSubmissionsSubmissionIdStatusHistoryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubmissionStatusHistoryFormsSubmissionsSubmissionIdStatusHistoryGet(requestParameters: FormsApiGetSubmissionStatusHistoryFormsSubmissionsSubmissionIdStatusHistoryGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionStatusHistoryOutput> {
            return localVarFp.getSubmissionStatusHistoryFormsSubmissionsSubmissionIdStatusHistoryGet(requestParameters.submissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all options for a field (public endpoint).
         * @summary List Field Options
         * @param {FormsApiListFieldOptionsFormsFieldsFieldIdOptionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFieldOptionsFormsFieldsFieldIdOptionsGet(requestParameters: FormsApiListFieldOptionsFormsFieldsFieldIdOptionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<FieldOption>> {
            return localVarFp.listFieldOptionsFormsFieldsFieldIdOptionsGet(requestParameters.fieldId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all field templates.
         * @summary List Field Templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFieldTemplatesFormsTemplatesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<FieldTemplate>> {
            return localVarFp.listFieldTemplatesFormsTemplatesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * List all fields for a form (public endpoint).
         * @summary List Form Fields
         * @param {FormsApiListFormFieldsFormsFormIdFieldsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFormFieldsFormsFormIdFieldsGet(requestParameters: FormsApiListFormFieldsFormsFormIdFieldsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<FormField>> {
            return localVarFp.listFormFieldsFormsFormIdFieldsGet(requestParameters.formId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all submissions for a form.
         * @summary List Form Submissions
         * @param {FormsApiListFormSubmissionsFormsFormIdSubmissionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFormSubmissionsFormsFormIdSubmissionsGet(requestParameters: FormsApiListFormSubmissionsFormsFormIdSubmissionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<FormSubmission>> {
            return localVarFp.listFormSubmissionsFormsFormIdSubmissionsGet(requestParameters.formId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all tag mappings for a specific form.
         * @summary List Form Tag Mappings
         * @param {FormsApiListFormTagMappingsFormsFormIdTagMappingsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFormTagMappingsFormsFormIdTagMappingsGet(requestParameters: FormsApiListFormTagMappingsFormsFormIdTagMappingsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<FormTagMapping>> {
            return localVarFp.listFormTagMappingsFormsFormIdTagMappingsGet(requestParameters.formId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all forms for a community.
         * @summary List Forms
         * @param {FormsApiListFormsFormsCommunitiesCommunityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFormsFormsCommunitiesCommunityIdGet(requestParameters: FormsApiListFormsFormsCommunitiesCommunityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Form>> {
            return localVarFp.listFormsFormsCommunitiesCommunityIdGet(requestParameters.communityId, requestParameters.publishedOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * Reorder options within a field.  Uses bulk update in transaction (Option 1 pattern) to avoid unique constraint violations during reordering. All updates happen atomically.  Security: Validates that all option_ids belong to the specified field_id.
         * @summary Reorder Field Options
         * @param {FormsApiReorderFieldOptionsFormsFieldsFieldIdOptionsReorderPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderFieldOptionsFormsFieldsFieldIdOptionsReorderPost(requestParameters: FormsApiReorderFieldOptionsFormsFieldsFieldIdOptionsReorderPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReorderFieldOptionsOutput> {
            return localVarFp.reorderFieldOptionsFormsFieldsFieldIdOptionsReorderPost(requestParameters.fieldId, requestParameters.reorderFieldOptionsInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Reorder fields within a form.
         * @summary Reorder Form Fields
         * @param {FormsApiReorderFormFieldsFormsFormIdFieldsReorderPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderFormFieldsFormsFormIdFieldsReorderPost(requestParameters: FormsApiReorderFormFieldsFormsFormIdFieldsReorderPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReorderFormFieldsOutput> {
            return localVarFp.reorderFormFieldsFormsFormIdFieldsReorderPost(requestParameters.formId, requestParameters.reorderFormFieldsInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Review a form submission.
         * @summary Review Form Submission
         * @param {FormsApiReviewFormSubmissionFormsSubmissionsSubmissionIdReviewPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewFormSubmissionFormsSubmissionsSubmissionIdReviewPatch(requestParameters: FormsApiReviewFormSubmissionFormsSubmissionsSubmissionIdReviewPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormSubmission> {
            return localVarFp.reviewFormSubmissionFormsSubmissionsSubmissionIdReviewPatch(requestParameters.submissionId, requestParameters.reviewFormSubmissionInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a field option.
         * @summary Update Field Option
         * @param {FormsApiUpdateFieldOptionFormsOptionsOptionIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFieldOptionFormsOptionsOptionIdPut(requestParameters: FormsApiUpdateFieldOptionFormsOptionsOptionIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<FieldOption> {
            return localVarFp.updateFieldOptionFormsOptionsOptionIdPut(requestParameters.optionId, requestParameters.updateFieldOptionInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a field template.
         * @summary Update Field Template
         * @param {FormsApiUpdateFieldTemplateFormsTemplatesTemplateIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFieldTemplateFormsTemplatesTemplateIdPut(requestParameters: FormsApiUpdateFieldTemplateFormsTemplatesTemplateIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<FieldTemplate> {
            return localVarFp.updateFieldTemplateFormsTemplatesTemplateIdPut(requestParameters.templateId, requestParameters.updateFieldTemplateInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a form field.
         * @summary Update Form Field
         * @param {FormsApiUpdateFormFieldFormsFieldsFieldIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFormFieldFormsFieldsFieldIdPut(requestParameters: FormsApiUpdateFormFieldFormsFieldsFieldIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormField> {
            return localVarFp.updateFormFieldFormsFieldsFieldIdPut(requestParameters.fieldId, requestParameters.updateFormFieldInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a form.
         * @summary Update Form
         * @param {FormsApiUpdateFormFormsFormIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFormFormsFormIdPut(requestParameters: FormsApiUpdateFormFormsFormIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<Form> {
            return localVarFp.updateFormFormsFormIdPut(requestParameters.formId, requestParameters.updateFormInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a form tag mapping.
         * @summary Update Form Tag Mapping
         * @param {FormsApiUpdateFormTagMappingFormsTagMappingsMappingIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFormTagMappingFormsTagMappingsMappingIdPut(requestParameters: FormsApiUpdateFormTagMappingFormsTagMappingsMappingIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormTagMapping> {
            return localVarFp.updateFormTagMappingFormsTagMappingsMappingIdPut(requestParameters.mappingId, requestParameters.updateFormTagMappingInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the status of an application form submission.
         * @summary Update Submission Status
         * @param {FormsApiUpdateSubmissionStatusFormsSubmissionsSubmissionIdStatusPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubmissionStatusFormsSubmissionsSubmissionIdStatusPatch(requestParameters: FormsApiUpdateSubmissionStatusFormsSubmissionsSubmissionIdStatusPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateSubmissionStatusOutput> {
            return localVarFp.updateSubmissionStatusFormsSubmissionsSubmissionIdStatusPatch(requestParameters.submissionId, requestParameters.updateFormSubmissionStatusInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for bulkGetSubmissionResponsesFormsSubmissionsResponsesBulkPost operation in FormsApi.
 * @export
 * @interface FormsApiBulkGetSubmissionResponsesFormsSubmissionsResponsesBulkPostRequest
 */
export interface FormsApiBulkGetSubmissionResponsesFormsSubmissionsResponsesBulkPostRequest {
    /**
     * 
     * @type {BulkGetSubmissionResponsesInput}
     * @memberof FormsApiBulkGetSubmissionResponsesFormsSubmissionsResponsesBulkPost
     */
    readonly bulkGetSubmissionResponsesInput: BulkGetSubmissionResponsesInput
}

/**
 * Request parameters for createFieldOptionFormsOptionsPost operation in FormsApi.
 * @export
 * @interface FormsApiCreateFieldOptionFormsOptionsPostRequest
 */
export interface FormsApiCreateFieldOptionFormsOptionsPostRequest {
    /**
     * 
     * @type {CreateFieldOptionInput}
     * @memberof FormsApiCreateFieldOptionFormsOptionsPost
     */
    readonly createFieldOptionInput: CreateFieldOptionInput
}

/**
 * Request parameters for createFieldTemplateFormsTemplatesPost operation in FormsApi.
 * @export
 * @interface FormsApiCreateFieldTemplateFormsTemplatesPostRequest
 */
export interface FormsApiCreateFieldTemplateFormsTemplatesPostRequest {
    /**
     * 
     * @type {CreateFieldTemplateInput}
     * @memberof FormsApiCreateFieldTemplateFormsTemplatesPost
     */
    readonly createFieldTemplateInput: CreateFieldTemplateInput
}

/**
 * Request parameters for createFormFieldFormsFieldsPost operation in FormsApi.
 * @export
 * @interface FormsApiCreateFormFieldFormsFieldsPostRequest
 */
export interface FormsApiCreateFormFieldFormsFieldsPostRequest {
    /**
     * 
     * @type {CreateFormFieldInput}
     * @memberof FormsApiCreateFormFieldFormsFieldsPost
     */
    readonly createFormFieldInput: CreateFormFieldInput
}

/**
 * Request parameters for createFormFormsPost operation in FormsApi.
 * @export
 * @interface FormsApiCreateFormFormsPostRequest
 */
export interface FormsApiCreateFormFormsPostRequest {
    /**
     * 
     * @type {CreateFormInput}
     * @memberof FormsApiCreateFormFormsPost
     */
    readonly createFormInput: CreateFormInput
}

/**
 * Request parameters for createFormSubmissionFormsSubmissionsPost operation in FormsApi.
 * @export
 * @interface FormsApiCreateFormSubmissionFormsSubmissionsPostRequest
 */
export interface FormsApiCreateFormSubmissionFormsSubmissionsPostRequest {
    /**
     * 
     * @type {CreateFormSubmissionInput}
     * @memberof FormsApiCreateFormSubmissionFormsSubmissionsPost
     */
    readonly createFormSubmissionInput: CreateFormSubmissionInput
}

/**
 * Request parameters for createFormTagMappingFormsTagMappingsPost operation in FormsApi.
 * @export
 * @interface FormsApiCreateFormTagMappingFormsTagMappingsPostRequest
 */
export interface FormsApiCreateFormTagMappingFormsTagMappingsPostRequest {
    /**
     * 
     * @type {CreateFormTagMappingInput}
     * @memberof FormsApiCreateFormTagMappingFormsTagMappingsPost
     */
    readonly createFormTagMappingInput: CreateFormTagMappingInput
}

/**
 * Request parameters for deleteFieldOptionFormsOptionsOptionIdDelete operation in FormsApi.
 * @export
 * @interface FormsApiDeleteFieldOptionFormsOptionsOptionIdDeleteRequest
 */
export interface FormsApiDeleteFieldOptionFormsOptionsOptionIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiDeleteFieldOptionFormsOptionsOptionIdDelete
     */
    readonly optionId: string
}

/**
 * Request parameters for deleteFieldTemplateFormsTemplatesTemplateIdDelete operation in FormsApi.
 * @export
 * @interface FormsApiDeleteFieldTemplateFormsTemplatesTemplateIdDeleteRequest
 */
export interface FormsApiDeleteFieldTemplateFormsTemplatesTemplateIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiDeleteFieldTemplateFormsTemplatesTemplateIdDelete
     */
    readonly templateId: string
}

/**
 * Request parameters for deleteFormFieldFormsFieldsFieldIdDelete operation in FormsApi.
 * @export
 * @interface FormsApiDeleteFormFieldFormsFieldsFieldIdDeleteRequest
 */
export interface FormsApiDeleteFormFieldFormsFieldsFieldIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiDeleteFormFieldFormsFieldsFieldIdDelete
     */
    readonly fieldId: string
}

/**
 * Request parameters for deleteFormFormsFormIdDelete operation in FormsApi.
 * @export
 * @interface FormsApiDeleteFormFormsFormIdDeleteRequest
 */
export interface FormsApiDeleteFormFormsFormIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiDeleteFormFormsFormIdDelete
     */
    readonly formId: string
}

/**
 * Request parameters for deleteFormSubmissionFormsSubmissionsSubmissionIdDelete operation in FormsApi.
 * @export
 * @interface FormsApiDeleteFormSubmissionFormsSubmissionsSubmissionIdDeleteRequest
 */
export interface FormsApiDeleteFormSubmissionFormsSubmissionsSubmissionIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiDeleteFormSubmissionFormsSubmissionsSubmissionIdDelete
     */
    readonly submissionId: string
}

/**
 * Request parameters for deleteFormTagMappingFormsTagMappingsMappingIdDelete operation in FormsApi.
 * @export
 * @interface FormsApiDeleteFormTagMappingFormsTagMappingsMappingIdDeleteRequest
 */
export interface FormsApiDeleteFormTagMappingFormsTagMappingsMappingIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiDeleteFormTagMappingFormsTagMappingsMappingIdDelete
     */
    readonly mappingId: string
}

/**
 * Request parameters for getFieldOptionFormsOptionsOptionIdGet operation in FormsApi.
 * @export
 * @interface FormsApiGetFieldOptionFormsOptionsOptionIdGetRequest
 */
export interface FormsApiGetFieldOptionFormsOptionsOptionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiGetFieldOptionFormsOptionsOptionIdGet
     */
    readonly optionId: string
}

/**
 * Request parameters for getFieldTemplateFormsTemplatesTemplateIdGet operation in FormsApi.
 * @export
 * @interface FormsApiGetFieldTemplateFormsTemplatesTemplateIdGetRequest
 */
export interface FormsApiGetFieldTemplateFormsTemplatesTemplateIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiGetFieldTemplateFormsTemplatesTemplateIdGet
     */
    readonly templateId: string
}

/**
 * Request parameters for getFormBySlugFormsSlugSlugGet operation in FormsApi.
 * @export
 * @interface FormsApiGetFormBySlugFormsSlugSlugGetRequest
 */
export interface FormsApiGetFormBySlugFormsSlugSlugGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiGetFormBySlugFormsSlugSlugGet
     */
    readonly slug: string
}

/**
 * Request parameters for getFormFieldFormsFieldsFieldIdGet operation in FormsApi.
 * @export
 * @interface FormsApiGetFormFieldFormsFieldsFieldIdGetRequest
 */
export interface FormsApiGetFormFieldFormsFieldsFieldIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiGetFormFieldFormsFieldsFieldIdGet
     */
    readonly fieldId: string
}

/**
 * Request parameters for getFormFormsFormIdGet operation in FormsApi.
 * @export
 * @interface FormsApiGetFormFormsFormIdGetRequest
 */
export interface FormsApiGetFormFormsFormIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiGetFormFormsFormIdGet
     */
    readonly formId: string
}

/**
 * Request parameters for getFormSubmissionFormsSubmissionsSubmissionIdGet operation in FormsApi.
 * @export
 * @interface FormsApiGetFormSubmissionFormsSubmissionsSubmissionIdGetRequest
 */
export interface FormsApiGetFormSubmissionFormsSubmissionsSubmissionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiGetFormSubmissionFormsSubmissionsSubmissionIdGet
     */
    readonly submissionId: string
}

/**
 * Request parameters for getFormTagMappingFormsTagMappingsMappingIdGet operation in FormsApi.
 * @export
 * @interface FormsApiGetFormTagMappingFormsTagMappingsMappingIdGetRequest
 */
export interface FormsApiGetFormTagMappingFormsTagMappingsMappingIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiGetFormTagMappingFormsTagMappingsMappingIdGet
     */
    readonly mappingId: string
}

/**
 * Request parameters for getSubmissionResponsesFormsSubmissionsSubmissionIdResponsesGet operation in FormsApi.
 * @export
 * @interface FormsApiGetSubmissionResponsesFormsSubmissionsSubmissionIdResponsesGetRequest
 */
export interface FormsApiGetSubmissionResponsesFormsSubmissionsSubmissionIdResponsesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiGetSubmissionResponsesFormsSubmissionsSubmissionIdResponsesGet
     */
    readonly submissionId: string
}

/**
 * Request parameters for getSubmissionStatusHistoryFormsSubmissionsSubmissionIdStatusHistoryGet operation in FormsApi.
 * @export
 * @interface FormsApiGetSubmissionStatusHistoryFormsSubmissionsSubmissionIdStatusHistoryGetRequest
 */
export interface FormsApiGetSubmissionStatusHistoryFormsSubmissionsSubmissionIdStatusHistoryGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiGetSubmissionStatusHistoryFormsSubmissionsSubmissionIdStatusHistoryGet
     */
    readonly submissionId: string
}

/**
 * Request parameters for listFieldOptionsFormsFieldsFieldIdOptionsGet operation in FormsApi.
 * @export
 * @interface FormsApiListFieldOptionsFormsFieldsFieldIdOptionsGetRequest
 */
export interface FormsApiListFieldOptionsFormsFieldsFieldIdOptionsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiListFieldOptionsFormsFieldsFieldIdOptionsGet
     */
    readonly fieldId: string
}

/**
 * Request parameters for listFormFieldsFormsFormIdFieldsGet operation in FormsApi.
 * @export
 * @interface FormsApiListFormFieldsFormsFormIdFieldsGetRequest
 */
export interface FormsApiListFormFieldsFormsFormIdFieldsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiListFormFieldsFormsFormIdFieldsGet
     */
    readonly formId: string
}

/**
 * Request parameters for listFormSubmissionsFormsFormIdSubmissionsGet operation in FormsApi.
 * @export
 * @interface FormsApiListFormSubmissionsFormsFormIdSubmissionsGetRequest
 */
export interface FormsApiListFormSubmissionsFormsFormIdSubmissionsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiListFormSubmissionsFormsFormIdSubmissionsGet
     */
    readonly formId: string
}

/**
 * Request parameters for listFormTagMappingsFormsFormIdTagMappingsGet operation in FormsApi.
 * @export
 * @interface FormsApiListFormTagMappingsFormsFormIdTagMappingsGetRequest
 */
export interface FormsApiListFormTagMappingsFormsFormIdTagMappingsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiListFormTagMappingsFormsFormIdTagMappingsGet
     */
    readonly formId: string
}

/**
 * Request parameters for listFormsFormsCommunitiesCommunityIdGet operation in FormsApi.
 * @export
 * @interface FormsApiListFormsFormsCommunitiesCommunityIdGetRequest
 */
export interface FormsApiListFormsFormsCommunitiesCommunityIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiListFormsFormsCommunitiesCommunityIdGet
     */
    readonly communityId: string

    /**
     * 
     * @type {boolean}
     * @memberof FormsApiListFormsFormsCommunitiesCommunityIdGet
     */
    readonly publishedOnly?: boolean
}

/**
 * Request parameters for reorderFieldOptionsFormsFieldsFieldIdOptionsReorderPost operation in FormsApi.
 * @export
 * @interface FormsApiReorderFieldOptionsFormsFieldsFieldIdOptionsReorderPostRequest
 */
export interface FormsApiReorderFieldOptionsFormsFieldsFieldIdOptionsReorderPostRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiReorderFieldOptionsFormsFieldsFieldIdOptionsReorderPost
     */
    readonly fieldId: string

    /**
     * 
     * @type {ReorderFieldOptionsInput}
     * @memberof FormsApiReorderFieldOptionsFormsFieldsFieldIdOptionsReorderPost
     */
    readonly reorderFieldOptionsInput: ReorderFieldOptionsInput
}

/**
 * Request parameters for reorderFormFieldsFormsFormIdFieldsReorderPost operation in FormsApi.
 * @export
 * @interface FormsApiReorderFormFieldsFormsFormIdFieldsReorderPostRequest
 */
export interface FormsApiReorderFormFieldsFormsFormIdFieldsReorderPostRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiReorderFormFieldsFormsFormIdFieldsReorderPost
     */
    readonly formId: string

    /**
     * 
     * @type {ReorderFormFieldsInput}
     * @memberof FormsApiReorderFormFieldsFormsFormIdFieldsReorderPost
     */
    readonly reorderFormFieldsInput: ReorderFormFieldsInput
}

/**
 * Request parameters for reviewFormSubmissionFormsSubmissionsSubmissionIdReviewPatch operation in FormsApi.
 * @export
 * @interface FormsApiReviewFormSubmissionFormsSubmissionsSubmissionIdReviewPatchRequest
 */
export interface FormsApiReviewFormSubmissionFormsSubmissionsSubmissionIdReviewPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiReviewFormSubmissionFormsSubmissionsSubmissionIdReviewPatch
     */
    readonly submissionId: string

    /**
     * 
     * @type {ReviewFormSubmissionInput}
     * @memberof FormsApiReviewFormSubmissionFormsSubmissionsSubmissionIdReviewPatch
     */
    readonly reviewFormSubmissionInput: ReviewFormSubmissionInput
}

/**
 * Request parameters for updateFieldOptionFormsOptionsOptionIdPut operation in FormsApi.
 * @export
 * @interface FormsApiUpdateFieldOptionFormsOptionsOptionIdPutRequest
 */
export interface FormsApiUpdateFieldOptionFormsOptionsOptionIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiUpdateFieldOptionFormsOptionsOptionIdPut
     */
    readonly optionId: string

    /**
     * 
     * @type {UpdateFieldOptionInput}
     * @memberof FormsApiUpdateFieldOptionFormsOptionsOptionIdPut
     */
    readonly updateFieldOptionInput: UpdateFieldOptionInput
}

/**
 * Request parameters for updateFieldTemplateFormsTemplatesTemplateIdPut operation in FormsApi.
 * @export
 * @interface FormsApiUpdateFieldTemplateFormsTemplatesTemplateIdPutRequest
 */
export interface FormsApiUpdateFieldTemplateFormsTemplatesTemplateIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiUpdateFieldTemplateFormsTemplatesTemplateIdPut
     */
    readonly templateId: string

    /**
     * 
     * @type {UpdateFieldTemplateInput}
     * @memberof FormsApiUpdateFieldTemplateFormsTemplatesTemplateIdPut
     */
    readonly updateFieldTemplateInput: UpdateFieldTemplateInput
}

/**
 * Request parameters for updateFormFieldFormsFieldsFieldIdPut operation in FormsApi.
 * @export
 * @interface FormsApiUpdateFormFieldFormsFieldsFieldIdPutRequest
 */
export interface FormsApiUpdateFormFieldFormsFieldsFieldIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiUpdateFormFieldFormsFieldsFieldIdPut
     */
    readonly fieldId: string

    /**
     * 
     * @type {UpdateFormFieldInput}
     * @memberof FormsApiUpdateFormFieldFormsFieldsFieldIdPut
     */
    readonly updateFormFieldInput: UpdateFormFieldInput
}

/**
 * Request parameters for updateFormFormsFormIdPut operation in FormsApi.
 * @export
 * @interface FormsApiUpdateFormFormsFormIdPutRequest
 */
export interface FormsApiUpdateFormFormsFormIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiUpdateFormFormsFormIdPut
     */
    readonly formId: string

    /**
     * 
     * @type {UpdateFormInput}
     * @memberof FormsApiUpdateFormFormsFormIdPut
     */
    readonly updateFormInput: UpdateFormInput
}

/**
 * Request parameters for updateFormTagMappingFormsTagMappingsMappingIdPut operation in FormsApi.
 * @export
 * @interface FormsApiUpdateFormTagMappingFormsTagMappingsMappingIdPutRequest
 */
export interface FormsApiUpdateFormTagMappingFormsTagMappingsMappingIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiUpdateFormTagMappingFormsTagMappingsMappingIdPut
     */
    readonly mappingId: string

    /**
     * 
     * @type {UpdateFormTagMappingInput}
     * @memberof FormsApiUpdateFormTagMappingFormsTagMappingsMappingIdPut
     */
    readonly updateFormTagMappingInput: UpdateFormTagMappingInput
}

/**
 * Request parameters for updateSubmissionStatusFormsSubmissionsSubmissionIdStatusPatch operation in FormsApi.
 * @export
 * @interface FormsApiUpdateSubmissionStatusFormsSubmissionsSubmissionIdStatusPatchRequest
 */
export interface FormsApiUpdateSubmissionStatusFormsSubmissionsSubmissionIdStatusPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof FormsApiUpdateSubmissionStatusFormsSubmissionsSubmissionIdStatusPatch
     */
    readonly submissionId: string

    /**
     * 
     * @type {UpdateFormSubmissionStatusInput}
     * @memberof FormsApiUpdateSubmissionStatusFormsSubmissionsSubmissionIdStatusPatch
     */
    readonly updateFormSubmissionStatusInput: UpdateFormSubmissionStatusInput
}

/**
 * FormsApi - object-oriented interface
 * @export
 * @class FormsApi
 * @extends {BaseAPI}
 */
export class FormsApi extends BaseAPI {
    /**
     * Get field responses for multiple form submissions in bulk.
     * @summary Bulk Get Submission Responses
     * @param {FormsApiBulkGetSubmissionResponsesFormsSubmissionsResponsesBulkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public bulkGetSubmissionResponsesFormsSubmissionsResponsesBulkPost(requestParameters: FormsApiBulkGetSubmissionResponsesFormsSubmissionsResponsesBulkPostRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).bulkGetSubmissionResponsesFormsSubmissionsResponsesBulkPost(requestParameters.bulkGetSubmissionResponsesInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new field option.
     * @summary Create Field Option
     * @param {FormsApiCreateFieldOptionFormsOptionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public createFieldOptionFormsOptionsPost(requestParameters: FormsApiCreateFieldOptionFormsOptionsPostRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).createFieldOptionFormsOptionsPost(requestParameters.createFieldOptionInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new field template.
     * @summary Create Field Template
     * @param {FormsApiCreateFieldTemplateFormsTemplatesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public createFieldTemplateFormsTemplatesPost(requestParameters: FormsApiCreateFieldTemplateFormsTemplatesPostRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).createFieldTemplateFormsTemplatesPost(requestParameters.createFieldTemplateInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new form field.
     * @summary Create Form Field
     * @param {FormsApiCreateFormFieldFormsFieldsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public createFormFieldFormsFieldsPost(requestParameters: FormsApiCreateFormFieldFormsFieldsPostRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).createFormFieldFormsFieldsPost(requestParameters.createFormFieldInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new form.
     * @summary Create Form
     * @param {FormsApiCreateFormFormsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public createFormFormsPost(requestParameters: FormsApiCreateFormFormsPostRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).createFormFormsPost(requestParameters.createFormInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new form submission (public endpoint).
     * @summary Create Form Submission
     * @param {FormsApiCreateFormSubmissionFormsSubmissionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public createFormSubmissionFormsSubmissionsPost(requestParameters: FormsApiCreateFormSubmissionFormsSubmissionsPostRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).createFormSubmissionFormsSubmissionsPost(requestParameters.createFormSubmissionInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new form tag mapping.
     * @summary Create Form Tag Mapping
     * @param {FormsApiCreateFormTagMappingFormsTagMappingsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public createFormTagMappingFormsTagMappingsPost(requestParameters: FormsApiCreateFormTagMappingFormsTagMappingsPostRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).createFormTagMappingFormsTagMappingsPost(requestParameters.createFormTagMappingInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a field option.
     * @summary Delete Field Option
     * @param {FormsApiDeleteFieldOptionFormsOptionsOptionIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public deleteFieldOptionFormsOptionsOptionIdDelete(requestParameters: FormsApiDeleteFieldOptionFormsOptionsOptionIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).deleteFieldOptionFormsOptionsOptionIdDelete(requestParameters.optionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a field template.
     * @summary Delete Field Template
     * @param {FormsApiDeleteFieldTemplateFormsTemplatesTemplateIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public deleteFieldTemplateFormsTemplatesTemplateIdDelete(requestParameters: FormsApiDeleteFieldTemplateFormsTemplatesTemplateIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).deleteFieldTemplateFormsTemplatesTemplateIdDelete(requestParameters.templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a form field.
     * @summary Delete Form Field
     * @param {FormsApiDeleteFormFieldFormsFieldsFieldIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public deleteFormFieldFormsFieldsFieldIdDelete(requestParameters: FormsApiDeleteFormFieldFormsFieldsFieldIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).deleteFormFieldFormsFieldsFieldIdDelete(requestParameters.fieldId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a form.
     * @summary Delete Form
     * @param {FormsApiDeleteFormFormsFormIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public deleteFormFormsFormIdDelete(requestParameters: FormsApiDeleteFormFormsFormIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).deleteFormFormsFormIdDelete(requestParameters.formId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a form submission.
     * @summary Delete Form Submission
     * @param {FormsApiDeleteFormSubmissionFormsSubmissionsSubmissionIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public deleteFormSubmissionFormsSubmissionsSubmissionIdDelete(requestParameters: FormsApiDeleteFormSubmissionFormsSubmissionsSubmissionIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).deleteFormSubmissionFormsSubmissionsSubmissionIdDelete(requestParameters.submissionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a form tag mapping.
     * @summary Delete Form Tag Mapping
     * @param {FormsApiDeleteFormTagMappingFormsTagMappingsMappingIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public deleteFormTagMappingFormsTagMappingsMappingIdDelete(requestParameters: FormsApiDeleteFormTagMappingFormsTagMappingsMappingIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).deleteFormTagMappingFormsTagMappingsMappingIdDelete(requestParameters.mappingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a field option by ID.
     * @summary Get Field Option
     * @param {FormsApiGetFieldOptionFormsOptionsOptionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public getFieldOptionFormsOptionsOptionIdGet(requestParameters: FormsApiGetFieldOptionFormsOptionsOptionIdGetRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).getFieldOptionFormsOptionsOptionIdGet(requestParameters.optionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a field template by ID.
     * @summary Get Field Template
     * @param {FormsApiGetFieldTemplateFormsTemplatesTemplateIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public getFieldTemplateFormsTemplatesTemplateIdGet(requestParameters: FormsApiGetFieldTemplateFormsTemplatesTemplateIdGetRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).getFieldTemplateFormsTemplatesTemplateIdGet(requestParameters.templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a form by slug (public endpoint for form display).
     * @summary Get Form By Slug
     * @param {FormsApiGetFormBySlugFormsSlugSlugGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public getFormBySlugFormsSlugSlugGet(requestParameters: FormsApiGetFormBySlugFormsSlugSlugGetRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).getFormBySlugFormsSlugSlugGet(requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a form field by ID.
     * @summary Get Form Field
     * @param {FormsApiGetFormFieldFormsFieldsFieldIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public getFormFieldFormsFieldsFieldIdGet(requestParameters: FormsApiGetFormFieldFormsFieldsFieldIdGetRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).getFormFieldFormsFieldsFieldIdGet(requestParameters.fieldId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a form by ID.
     * @summary Get Form
     * @param {FormsApiGetFormFormsFormIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public getFormFormsFormIdGet(requestParameters: FormsApiGetFormFormsFormIdGetRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).getFormFormsFormIdGet(requestParameters.formId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a form submission by ID.
     * @summary Get Form Submission
     * @param {FormsApiGetFormSubmissionFormsSubmissionsSubmissionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public getFormSubmissionFormsSubmissionsSubmissionIdGet(requestParameters: FormsApiGetFormSubmissionFormsSubmissionsSubmissionIdGetRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).getFormSubmissionFormsSubmissionsSubmissionIdGet(requestParameters.submissionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a form tag mapping by ID.
     * @summary Get Form Tag Mapping
     * @param {FormsApiGetFormTagMappingFormsTagMappingsMappingIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public getFormTagMappingFormsTagMappingsMappingIdGet(requestParameters: FormsApiGetFormTagMappingFormsTagMappingsMappingIdGetRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).getFormTagMappingFormsTagMappingsMappingIdGet(requestParameters.mappingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all field responses for a specific form submission.
     * @summary Get Submission Responses
     * @param {FormsApiGetSubmissionResponsesFormsSubmissionsSubmissionIdResponsesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public getSubmissionResponsesFormsSubmissionsSubmissionIdResponsesGet(requestParameters: FormsApiGetSubmissionResponsesFormsSubmissionsSubmissionIdResponsesGetRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).getSubmissionResponsesFormsSubmissionsSubmissionIdResponsesGet(requestParameters.submissionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the status change history for a form submission.
     * @summary Get Submission Status History
     * @param {FormsApiGetSubmissionStatusHistoryFormsSubmissionsSubmissionIdStatusHistoryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public getSubmissionStatusHistoryFormsSubmissionsSubmissionIdStatusHistoryGet(requestParameters: FormsApiGetSubmissionStatusHistoryFormsSubmissionsSubmissionIdStatusHistoryGetRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).getSubmissionStatusHistoryFormsSubmissionsSubmissionIdStatusHistoryGet(requestParameters.submissionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all options for a field (public endpoint).
     * @summary List Field Options
     * @param {FormsApiListFieldOptionsFormsFieldsFieldIdOptionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public listFieldOptionsFormsFieldsFieldIdOptionsGet(requestParameters: FormsApiListFieldOptionsFormsFieldsFieldIdOptionsGetRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).listFieldOptionsFormsFieldsFieldIdOptionsGet(requestParameters.fieldId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all field templates.
     * @summary List Field Templates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public listFieldTemplatesFormsTemplatesGet(options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).listFieldTemplatesFormsTemplatesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all fields for a form (public endpoint).
     * @summary List Form Fields
     * @param {FormsApiListFormFieldsFormsFormIdFieldsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public listFormFieldsFormsFormIdFieldsGet(requestParameters: FormsApiListFormFieldsFormsFormIdFieldsGetRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).listFormFieldsFormsFormIdFieldsGet(requestParameters.formId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all submissions for a form.
     * @summary List Form Submissions
     * @param {FormsApiListFormSubmissionsFormsFormIdSubmissionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public listFormSubmissionsFormsFormIdSubmissionsGet(requestParameters: FormsApiListFormSubmissionsFormsFormIdSubmissionsGetRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).listFormSubmissionsFormsFormIdSubmissionsGet(requestParameters.formId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all tag mappings for a specific form.
     * @summary List Form Tag Mappings
     * @param {FormsApiListFormTagMappingsFormsFormIdTagMappingsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public listFormTagMappingsFormsFormIdTagMappingsGet(requestParameters: FormsApiListFormTagMappingsFormsFormIdTagMappingsGetRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).listFormTagMappingsFormsFormIdTagMappingsGet(requestParameters.formId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all forms for a community.
     * @summary List Forms
     * @param {FormsApiListFormsFormsCommunitiesCommunityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public listFormsFormsCommunitiesCommunityIdGet(requestParameters: FormsApiListFormsFormsCommunitiesCommunityIdGetRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).listFormsFormsCommunitiesCommunityIdGet(requestParameters.communityId, requestParameters.publishedOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reorder options within a field.  Uses bulk update in transaction (Option 1 pattern) to avoid unique constraint violations during reordering. All updates happen atomically.  Security: Validates that all option_ids belong to the specified field_id.
     * @summary Reorder Field Options
     * @param {FormsApiReorderFieldOptionsFormsFieldsFieldIdOptionsReorderPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public reorderFieldOptionsFormsFieldsFieldIdOptionsReorderPost(requestParameters: FormsApiReorderFieldOptionsFormsFieldsFieldIdOptionsReorderPostRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).reorderFieldOptionsFormsFieldsFieldIdOptionsReorderPost(requestParameters.fieldId, requestParameters.reorderFieldOptionsInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reorder fields within a form.
     * @summary Reorder Form Fields
     * @param {FormsApiReorderFormFieldsFormsFormIdFieldsReorderPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public reorderFormFieldsFormsFormIdFieldsReorderPost(requestParameters: FormsApiReorderFormFieldsFormsFormIdFieldsReorderPostRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).reorderFormFieldsFormsFormIdFieldsReorderPost(requestParameters.formId, requestParameters.reorderFormFieldsInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Review a form submission.
     * @summary Review Form Submission
     * @param {FormsApiReviewFormSubmissionFormsSubmissionsSubmissionIdReviewPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public reviewFormSubmissionFormsSubmissionsSubmissionIdReviewPatch(requestParameters: FormsApiReviewFormSubmissionFormsSubmissionsSubmissionIdReviewPatchRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).reviewFormSubmissionFormsSubmissionsSubmissionIdReviewPatch(requestParameters.submissionId, requestParameters.reviewFormSubmissionInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a field option.
     * @summary Update Field Option
     * @param {FormsApiUpdateFieldOptionFormsOptionsOptionIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public updateFieldOptionFormsOptionsOptionIdPut(requestParameters: FormsApiUpdateFieldOptionFormsOptionsOptionIdPutRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).updateFieldOptionFormsOptionsOptionIdPut(requestParameters.optionId, requestParameters.updateFieldOptionInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a field template.
     * @summary Update Field Template
     * @param {FormsApiUpdateFieldTemplateFormsTemplatesTemplateIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public updateFieldTemplateFormsTemplatesTemplateIdPut(requestParameters: FormsApiUpdateFieldTemplateFormsTemplatesTemplateIdPutRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).updateFieldTemplateFormsTemplatesTemplateIdPut(requestParameters.templateId, requestParameters.updateFieldTemplateInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a form field.
     * @summary Update Form Field
     * @param {FormsApiUpdateFormFieldFormsFieldsFieldIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public updateFormFieldFormsFieldsFieldIdPut(requestParameters: FormsApiUpdateFormFieldFormsFieldsFieldIdPutRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).updateFormFieldFormsFieldsFieldIdPut(requestParameters.fieldId, requestParameters.updateFormFieldInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a form.
     * @summary Update Form
     * @param {FormsApiUpdateFormFormsFormIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public updateFormFormsFormIdPut(requestParameters: FormsApiUpdateFormFormsFormIdPutRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).updateFormFormsFormIdPut(requestParameters.formId, requestParameters.updateFormInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a form tag mapping.
     * @summary Update Form Tag Mapping
     * @param {FormsApiUpdateFormTagMappingFormsTagMappingsMappingIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public updateFormTagMappingFormsTagMappingsMappingIdPut(requestParameters: FormsApiUpdateFormTagMappingFormsTagMappingsMappingIdPutRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).updateFormTagMappingFormsTagMappingsMappingIdPut(requestParameters.mappingId, requestParameters.updateFormTagMappingInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the status of an application form submission.
     * @summary Update Submission Status
     * @param {FormsApiUpdateSubmissionStatusFormsSubmissionsSubmissionIdStatusPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApi
     */
    public updateSubmissionStatusFormsSubmissionsSubmissionIdStatusPatch(requestParameters: FormsApiUpdateSubmissionStatusFormsSubmissionsSubmissionIdStatusPatchRequest, options?: RawAxiosRequestConfig) {
        return FormsApiFp(this.configuration).updateSubmissionStatusFormsSubmissionsSubmissionIdStatusPatch(requestParameters.submissionId, requestParameters.updateFormSubmissionStatusInput, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LinksApi - axios parameter creator
 * @export
 */
export const LinksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new shortened link.
         * @summary Create Link
         * @param {CreateLinkInput} createLinkInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLinkLinksPost: async (createLinkInput: CreateLinkInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createLinkInput' is not null or undefined
            assertParamExists('createLinkLinksPost', 'createLinkInput', createLinkInput)
            const localVarPath = `/links/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLinkInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a link (soft delete).
         * @summary Delete Link
         * @param {string} linkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLinkLinksLinkIdDelete: async (linkId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'linkId' is not null or undefined
            assertParamExists('deleteLinkLinksLinkIdDelete', 'linkId', linkId)
            const localVarPath = `/links/{link_id}/`
                .replace(`{${"link_id"}}`, encodeURIComponent(String(linkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get analytics for a specific link.
         * @summary Get Link Analytics
         * @param {string} linkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinkAnalyticsLinksLinkIdAnalyticsGet: async (linkId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'linkId' is not null or undefined
            assertParamExists('getLinkAnalyticsLinksLinkIdAnalyticsGet', 'linkId', linkId)
            const localVarPath = `/links/{link_id}/analytics/`
                .replace(`{${"link_id"}}`, encodeURIComponent(String(linkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get clicks for a specific link.
         * @summary Get Link Clicks
         * @param {string} linkId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinkClicksLinksLinkIdClicksGet: async (linkId: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'linkId' is not null or undefined
            assertParamExists('getLinkClicksLinksLinkIdClicksGet', 'linkId', linkId)
            const localVarPath = `/links/{link_id}/clicks/`
                .replace(`{${"link_id"}}`, encodeURIComponent(String(linkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Public endpoint to get the destination URL for a shortened link. Returns the URL for client-side redirect. Does NOT track the click. Use the POST /clicks/ endpoint to track clicks with client data.
         * @summary Get Link Destination
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinkDestinationLinksRSlugGet: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('getLinkDestinationLinksRSlugGet', 'slug', slug)
            const localVarPath = `/links/r/{slug}/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a link by ID.
         * @summary Get Link
         * @param {string} linkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinkLinksLinkIdGet: async (linkId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'linkId' is not null or undefined
            assertParamExists('getLinkLinksLinkIdGet', 'linkId', linkId)
            const localVarPath = `/links/{link_id}/`
                .replace(`{${"link_id"}}`, encodeURIComponent(String(linkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all links for a community.
         * @summary List Links
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLinksLinksCommunitiesCommunityIdGet: async (communityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('listLinksLinksCommunitiesCommunityIdGet', 'communityId', communityId)
            const localVarPath = `/links/communities/{community_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Public endpoint to record a link click with tracking data. Called by the client after getting the destination URL and before redirecting.  IP address is extracted from request headers server-side (X-Forwarded-For). Client sends all other tracking data (user_agent, referer, device info).
         * @summary Record Link Click
         * @param {RecordLinkClickInput} recordLinkClickInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordLinkClickLinksClicksPost: async (recordLinkClickInput: RecordLinkClickInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordLinkClickInput' is not null or undefined
            assertParamExists('recordLinkClickLinksClicksPost', 'recordLinkClickInput', recordLinkClickInput)
            const localVarPath = `/links/clicks/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordLinkClickInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a link.
         * @summary Update Link
         * @param {string} linkId 
         * @param {UpdateLinkInput} updateLinkInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLinkLinksLinkIdPut: async (linkId: string, updateLinkInput: UpdateLinkInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'linkId' is not null or undefined
            assertParamExists('updateLinkLinksLinkIdPut', 'linkId', linkId)
            // verify required parameter 'updateLinkInput' is not null or undefined
            assertParamExists('updateLinkLinksLinkIdPut', 'updateLinkInput', updateLinkInput)
            const localVarPath = `/links/{link_id}/`
                .replace(`{${"link_id"}}`, encodeURIComponent(String(linkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLinkInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LinksApi - functional programming interface
 * @export
 */
export const LinksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LinksApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new shortened link.
         * @summary Create Link
         * @param {CreateLinkInput} createLinkInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLinkLinksPost(createLinkInput: CreateLinkInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Link>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLinkLinksPost(createLinkInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LinksApi.createLinkLinksPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Delete a link (soft delete).
         * @summary Delete Link
         * @param {string} linkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLinkLinksLinkIdDelete(linkId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteLinkOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLinkLinksLinkIdDelete(linkId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LinksApi.deleteLinkLinksLinkIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get analytics for a specific link.
         * @summary Get Link Analytics
         * @param {string} linkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLinkAnalyticsLinksLinkIdAnalyticsGet(linkId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LinkAnalyticsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLinkAnalyticsLinksLinkIdAnalyticsGet(linkId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LinksApi.getLinkAnalyticsLinksLinkIdAnalyticsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get clicks for a specific link.
         * @summary Get Link Clicks
         * @param {string} linkId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLinkClicksLinksLinkIdClicksGet(linkId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LinkClick>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLinkClicksLinksLinkIdClicksGet(linkId, limit, offset, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LinksApi.getLinkClicksLinksLinkIdClicksGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Public endpoint to get the destination URL for a shortened link. Returns the URL for client-side redirect. Does NOT track the click. Use the POST /clicks/ endpoint to track clicks with client data.
         * @summary Get Link Destination
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLinkDestinationLinksRSlugGet(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RedirectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLinkDestinationLinksRSlugGet(slug, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LinksApi.getLinkDestinationLinksRSlugGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get a link by ID.
         * @summary Get Link
         * @param {string} linkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLinkLinksLinkIdGet(linkId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Link>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLinkLinksLinkIdGet(linkId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LinksApi.getLinkLinksLinkIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List all links for a community.
         * @summary List Links
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLinksLinksCommunitiesCommunityIdGet(communityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Link>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLinksLinksCommunitiesCommunityIdGet(communityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LinksApi.listLinksLinksCommunitiesCommunityIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Public endpoint to record a link click with tracking data. Called by the client after getting the destination URL and before redirecting.  IP address is extracted from request headers server-side (X-Forwarded-For). Client sends all other tracking data (user_agent, referer, device info).
         * @summary Record Link Click
         * @param {RecordLinkClickInput} recordLinkClickInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordLinkClickLinksClicksPost(recordLinkClickInput: RecordLinkClickInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LinkClick>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordLinkClickLinksClicksPost(recordLinkClickInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LinksApi.recordLinkClickLinksClicksPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update a link.
         * @summary Update Link
         * @param {string} linkId 
         * @param {UpdateLinkInput} updateLinkInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLinkLinksLinkIdPut(linkId: string, updateLinkInput: UpdateLinkInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Link>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLinkLinksLinkIdPut(linkId, updateLinkInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LinksApi.updateLinkLinksLinkIdPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * LinksApi - factory interface
 * @export
 */
export const LinksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LinksApiFp(configuration)
    return {
        /**
         * Create a new shortened link.
         * @summary Create Link
         * @param {LinksApiCreateLinkLinksPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLinkLinksPost(requestParameters: LinksApiCreateLinkLinksPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Link> {
            return localVarFp.createLinkLinksPost(requestParameters.createLinkInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a link (soft delete).
         * @summary Delete Link
         * @param {LinksApiDeleteLinkLinksLinkIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLinkLinksLinkIdDelete(requestParameters: LinksApiDeleteLinkLinksLinkIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteLinkOutput> {
            return localVarFp.deleteLinkLinksLinkIdDelete(requestParameters.linkId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get analytics for a specific link.
         * @summary Get Link Analytics
         * @param {LinksApiGetLinkAnalyticsLinksLinkIdAnalyticsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinkAnalyticsLinksLinkIdAnalyticsGet(requestParameters: LinksApiGetLinkAnalyticsLinksLinkIdAnalyticsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<LinkAnalyticsOutput> {
            return localVarFp.getLinkAnalyticsLinksLinkIdAnalyticsGet(requestParameters.linkId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get clicks for a specific link.
         * @summary Get Link Clicks
         * @param {LinksApiGetLinkClicksLinksLinkIdClicksGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinkClicksLinksLinkIdClicksGet(requestParameters: LinksApiGetLinkClicksLinksLinkIdClicksGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<LinkClick>> {
            return localVarFp.getLinkClicksLinksLinkIdClicksGet(requestParameters.linkId, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Public endpoint to get the destination URL for a shortened link. Returns the URL for client-side redirect. Does NOT track the click. Use the POST /clicks/ endpoint to track clicks with client data.
         * @summary Get Link Destination
         * @param {LinksApiGetLinkDestinationLinksRSlugGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinkDestinationLinksRSlugGet(requestParameters: LinksApiGetLinkDestinationLinksRSlugGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RedirectResponse> {
            return localVarFp.getLinkDestinationLinksRSlugGet(requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a link by ID.
         * @summary Get Link
         * @param {LinksApiGetLinkLinksLinkIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinkLinksLinkIdGet(requestParameters: LinksApiGetLinkLinksLinkIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Link> {
            return localVarFp.getLinkLinksLinkIdGet(requestParameters.linkId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all links for a community.
         * @summary List Links
         * @param {LinksApiListLinksLinksCommunitiesCommunityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLinksLinksCommunitiesCommunityIdGet(requestParameters: LinksApiListLinksLinksCommunitiesCommunityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Link>> {
            return localVarFp.listLinksLinksCommunitiesCommunityIdGet(requestParameters.communityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Public endpoint to record a link click with tracking data. Called by the client after getting the destination URL and before redirecting.  IP address is extracted from request headers server-side (X-Forwarded-For). Client sends all other tracking data (user_agent, referer, device info).
         * @summary Record Link Click
         * @param {LinksApiRecordLinkClickLinksClicksPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordLinkClickLinksClicksPost(requestParameters: LinksApiRecordLinkClickLinksClicksPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LinkClick> {
            return localVarFp.recordLinkClickLinksClicksPost(requestParameters.recordLinkClickInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a link.
         * @summary Update Link
         * @param {LinksApiUpdateLinkLinksLinkIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLinkLinksLinkIdPut(requestParameters: LinksApiUpdateLinkLinksLinkIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<Link> {
            return localVarFp.updateLinkLinksLinkIdPut(requestParameters.linkId, requestParameters.updateLinkInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createLinkLinksPost operation in LinksApi.
 * @export
 * @interface LinksApiCreateLinkLinksPostRequest
 */
export interface LinksApiCreateLinkLinksPostRequest {
    /**
     * 
     * @type {CreateLinkInput}
     * @memberof LinksApiCreateLinkLinksPost
     */
    readonly createLinkInput: CreateLinkInput
}

/**
 * Request parameters for deleteLinkLinksLinkIdDelete operation in LinksApi.
 * @export
 * @interface LinksApiDeleteLinkLinksLinkIdDeleteRequest
 */
export interface LinksApiDeleteLinkLinksLinkIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof LinksApiDeleteLinkLinksLinkIdDelete
     */
    readonly linkId: string
}

/**
 * Request parameters for getLinkAnalyticsLinksLinkIdAnalyticsGet operation in LinksApi.
 * @export
 * @interface LinksApiGetLinkAnalyticsLinksLinkIdAnalyticsGetRequest
 */
export interface LinksApiGetLinkAnalyticsLinksLinkIdAnalyticsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof LinksApiGetLinkAnalyticsLinksLinkIdAnalyticsGet
     */
    readonly linkId: string
}

/**
 * Request parameters for getLinkClicksLinksLinkIdClicksGet operation in LinksApi.
 * @export
 * @interface LinksApiGetLinkClicksLinksLinkIdClicksGetRequest
 */
export interface LinksApiGetLinkClicksLinksLinkIdClicksGetRequest {
    /**
     * 
     * @type {string}
     * @memberof LinksApiGetLinkClicksLinksLinkIdClicksGet
     */
    readonly linkId: string

    /**
     * 
     * @type {number}
     * @memberof LinksApiGetLinkClicksLinksLinkIdClicksGet
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof LinksApiGetLinkClicksLinksLinkIdClicksGet
     */
    readonly offset?: number
}

/**
 * Request parameters for getLinkDestinationLinksRSlugGet operation in LinksApi.
 * @export
 * @interface LinksApiGetLinkDestinationLinksRSlugGetRequest
 */
export interface LinksApiGetLinkDestinationLinksRSlugGetRequest {
    /**
     * 
     * @type {string}
     * @memberof LinksApiGetLinkDestinationLinksRSlugGet
     */
    readonly slug: string
}

/**
 * Request parameters for getLinkLinksLinkIdGet operation in LinksApi.
 * @export
 * @interface LinksApiGetLinkLinksLinkIdGetRequest
 */
export interface LinksApiGetLinkLinksLinkIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof LinksApiGetLinkLinksLinkIdGet
     */
    readonly linkId: string
}

/**
 * Request parameters for listLinksLinksCommunitiesCommunityIdGet operation in LinksApi.
 * @export
 * @interface LinksApiListLinksLinksCommunitiesCommunityIdGetRequest
 */
export interface LinksApiListLinksLinksCommunitiesCommunityIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof LinksApiListLinksLinksCommunitiesCommunityIdGet
     */
    readonly communityId: string
}

/**
 * Request parameters for recordLinkClickLinksClicksPost operation in LinksApi.
 * @export
 * @interface LinksApiRecordLinkClickLinksClicksPostRequest
 */
export interface LinksApiRecordLinkClickLinksClicksPostRequest {
    /**
     * 
     * @type {RecordLinkClickInput}
     * @memberof LinksApiRecordLinkClickLinksClicksPost
     */
    readonly recordLinkClickInput: RecordLinkClickInput
}

/**
 * Request parameters for updateLinkLinksLinkIdPut operation in LinksApi.
 * @export
 * @interface LinksApiUpdateLinkLinksLinkIdPutRequest
 */
export interface LinksApiUpdateLinkLinksLinkIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof LinksApiUpdateLinkLinksLinkIdPut
     */
    readonly linkId: string

    /**
     * 
     * @type {UpdateLinkInput}
     * @memberof LinksApiUpdateLinkLinksLinkIdPut
     */
    readonly updateLinkInput: UpdateLinkInput
}

/**
 * LinksApi - object-oriented interface
 * @export
 * @class LinksApi
 * @extends {BaseAPI}
 */
export class LinksApi extends BaseAPI {
    /**
     * Create a new shortened link.
     * @summary Create Link
     * @param {LinksApiCreateLinkLinksPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LinksApi
     */
    public createLinkLinksPost(requestParameters: LinksApiCreateLinkLinksPostRequest, options?: RawAxiosRequestConfig) {
        return LinksApiFp(this.configuration).createLinkLinksPost(requestParameters.createLinkInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a link (soft delete).
     * @summary Delete Link
     * @param {LinksApiDeleteLinkLinksLinkIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LinksApi
     */
    public deleteLinkLinksLinkIdDelete(requestParameters: LinksApiDeleteLinkLinksLinkIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return LinksApiFp(this.configuration).deleteLinkLinksLinkIdDelete(requestParameters.linkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get analytics for a specific link.
     * @summary Get Link Analytics
     * @param {LinksApiGetLinkAnalyticsLinksLinkIdAnalyticsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LinksApi
     */
    public getLinkAnalyticsLinksLinkIdAnalyticsGet(requestParameters: LinksApiGetLinkAnalyticsLinksLinkIdAnalyticsGetRequest, options?: RawAxiosRequestConfig) {
        return LinksApiFp(this.configuration).getLinkAnalyticsLinksLinkIdAnalyticsGet(requestParameters.linkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get clicks for a specific link.
     * @summary Get Link Clicks
     * @param {LinksApiGetLinkClicksLinksLinkIdClicksGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LinksApi
     */
    public getLinkClicksLinksLinkIdClicksGet(requestParameters: LinksApiGetLinkClicksLinksLinkIdClicksGetRequest, options?: RawAxiosRequestConfig) {
        return LinksApiFp(this.configuration).getLinkClicksLinksLinkIdClicksGet(requestParameters.linkId, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Public endpoint to get the destination URL for a shortened link. Returns the URL for client-side redirect. Does NOT track the click. Use the POST /clicks/ endpoint to track clicks with client data.
     * @summary Get Link Destination
     * @param {LinksApiGetLinkDestinationLinksRSlugGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LinksApi
     */
    public getLinkDestinationLinksRSlugGet(requestParameters: LinksApiGetLinkDestinationLinksRSlugGetRequest, options?: RawAxiosRequestConfig) {
        return LinksApiFp(this.configuration).getLinkDestinationLinksRSlugGet(requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a link by ID.
     * @summary Get Link
     * @param {LinksApiGetLinkLinksLinkIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LinksApi
     */
    public getLinkLinksLinkIdGet(requestParameters: LinksApiGetLinkLinksLinkIdGetRequest, options?: RawAxiosRequestConfig) {
        return LinksApiFp(this.configuration).getLinkLinksLinkIdGet(requestParameters.linkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all links for a community.
     * @summary List Links
     * @param {LinksApiListLinksLinksCommunitiesCommunityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LinksApi
     */
    public listLinksLinksCommunitiesCommunityIdGet(requestParameters: LinksApiListLinksLinksCommunitiesCommunityIdGetRequest, options?: RawAxiosRequestConfig) {
        return LinksApiFp(this.configuration).listLinksLinksCommunitiesCommunityIdGet(requestParameters.communityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Public endpoint to record a link click with tracking data. Called by the client after getting the destination URL and before redirecting.  IP address is extracted from request headers server-side (X-Forwarded-For). Client sends all other tracking data (user_agent, referer, device info).
     * @summary Record Link Click
     * @param {LinksApiRecordLinkClickLinksClicksPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LinksApi
     */
    public recordLinkClickLinksClicksPost(requestParameters: LinksApiRecordLinkClickLinksClicksPostRequest, options?: RawAxiosRequestConfig) {
        return LinksApiFp(this.configuration).recordLinkClickLinksClicksPost(requestParameters.recordLinkClickInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a link.
     * @summary Update Link
     * @param {LinksApiUpdateLinkLinksLinkIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LinksApi
     */
    public updateLinkLinksLinkIdPut(requestParameters: LinksApiUpdateLinkLinksLinkIdPutRequest, options?: RawAxiosRequestConfig) {
        return LinksApiFp(this.configuration).updateLinkLinksLinkIdPut(requestParameters.linkId, requestParameters.updateLinkInput, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SystemApi - axios parameter creator
 * @export
 */
export const SystemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Health check endpoint for AWS load balancers and monitoring
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckHealthGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SystemApi - functional programming interface
 * @export
 */
export const SystemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SystemApiAxiosParamCreator(configuration)
    return {
        /**
         * Health check endpoint for AWS load balancers and monitoring
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheckHealthGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheckHealthGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SystemApi.healthCheckHealthGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * SystemApi - factory interface
 * @export
 */
export const SystemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SystemApiFp(configuration)
    return {
        /**
         * Health check endpoint for AWS load balancers and monitoring
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckHealthGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.healthCheckHealthGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SystemApi - object-oriented interface
 * @export
 * @class SystemApi
 * @extends {BaseAPI}
 */
export class SystemApi extends BaseAPI {
    /**
     * Health check endpoint for AWS load balancers and monitoring
     * @summary Health Check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public healthCheckHealthGet(options?: RawAxiosRequestConfig) {
        return SystemApiFp(this.configuration).healthCheckHealthGet(options).then((request) => request(this.axios, this.basePath));
    }
}



